import { call, put, takeEvery } from "redux-saga/effects";
import { AppConstants } from "../../Appconstants";
import { jwtDecode } from "jwt-decode";
import {
  ADD_TEAM,
  ADD_TEAM_FAILED,
  ADD_TEAM_SUCCESS,
  GET_TEAMS,
  GET_TEAMS_FAILED,
  GET_TEAMS_SUCCESS,
  EDIT_TEAM,
  EDIT_TEAM_FAILED,
  EDIT_TEAM_SUCCESS,
  DELETE_TEAM,
  DELETE_TEAM_FAILED,
  DELETE_TEAM_SUCCESS,
} from "../types/API/teamTypes";
import {
  LOGIN_USER,
  LOGIN_USER_FAILED,
  LOGIN_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  SIGNUP_USER_FAILED,
  SIGNUP_USER,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAILED,
  FORGOT_PASSWORD_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD,
} from "../types/API/authTypes";
import {
  ADD_BLOG,
  ADD_BLOG_FAILED,
  ADD_BLOG_SUCCESS,
  DELETE_BLOG,
  DELETE_BLOG_FAILED,
  DELETE_BLOG_SUCCESS,
  EDIT_BLOG,
  EDIT_BLOG_FAILED,
  EDIT_BLOG_SUCCESS,
  GET_BLOGS,
  GET_BLOG_BY_ID,
  GET_BLOG_BY_ID_FAILED,
  GET_BLOG_BY_ID_SUCCESS,
  GET_BLOGS_FAILED,
  GET_BLOGS_SUCCESS,
  GET_BLOGS_CATEGORIES_SUCCESS,
  GET_BLOGS_CATEGORIES_FAILED,
  GET_BLOGS_CATEGORIES,
  BLOGS_SEARCH_SUCCESS,
  BLOGS_SEARCH_FAILED,
  BLOGS_SEARCH,
} from "../types/API/blogTypes";
import {
  ADD_STORE,
  ADD_STORE_FAILED,
  ADD_STORE_SUCCESS,
  GET_STORE,
  GET_STORE_SUCCESS,
  GET_STORE_FAILED,
  EDIT_STORE,
  EDIT_STORE_SUCCESS,
  EDIT_STORE_FAILED,
  DELETE_STORE,
  DELETE_STORE_SUCCESS,
  DELETE_STORE_FAILED,
  GET_STORE_BY_ID,
  GET_STORE_BY_ID_SUCCESS,
  GET_STORE_BY_ID_FAILED,
  GET_STORE_BY_ITEMS_SUCCESS,
  GET_STORE_BY_ITEMS_FAILED,
  GET_STORE_BY_ITEMS,
  GET_STORE_BY_ITEM_SUCCESS,
  GET_STORE_BY_ITEM_FAILED,
  GET_STORE_BY_ITEM,
  GET_ALL_STORE_ITEMS_BY_STORES_ID,
  GET_ALL_STORE_ITEMS_BY_STORES_ID_SUCCESS,
  GET_ALL_STORE_ITEMS_BY_STORES_ID_FAILED,
  GET_ALL_STORES_WITH_ITEMS,
  GET_ALL_STORES_WITH_ITEMS_SUCCESS,
  GET_ALL_STORES_WITH_ITEMS_FAILED,
  GET_ALL_STOCKS_VALUES_SUCCESS,
  GET_ALL_STOCKS_VALUES_FAILED,
  GET_ALL_STOCKS_VALUES,
  GET_FIFO_PRICE_SUCCESS,
  GET_FIFO_PRICE_FAILED,
  GET_FIFO_PRICE,
  SET_DEFAULT_STORE_SUCCESS,
  SET_DEFAULT_STORE_FAILED,
  SET_DEFAULT_STORE,
} from "../types/API/storeTypes";
import {
  ADD_COMMENT,
  ADD_COMMENT_FAILED,
  ADD_COMMENT_SUCCESS,
  DELETE_COMMENT,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILED,
  APPROVE_COMMENT,
  APPROVE_COMMENT_SUCCESS,
  APPROVE_COMMENT_FAILED,
  GET_APPROVE_BLOG_COMMENT_SUCCESS,
  GET_APPROVE_BLOG_COMMENT_FAILED,
  GET_BLOG_COMMENTS_TO_BE_APPROVED_SUCCESS,
  GET_BLOG_COMMENTS_TO_BE_APPROVED_FAILED,
  GET_APPROVE_BLOG_COMMENT,
  GET_BLOG_COMMENTS_TO_BE_APPROVED,
  GET_ALL_BLOGS_APPROVED_COMMENTS,
  GET_ALL_BLOGS_APPROVED_COMMENTS_SUCCESS,
  GET_ALL_BLOGS_APPROVED_COMMENTS_FAILED,
} from "../types/API/commentTypes";
import {
  UPLOAD_IMAGE,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILED,
} from "../types/API/imageUploadTypes";
import {
  ADD_USER,
  ADD_USER_FAILED,
  ADD_USER_SUCCESS,
  DELETE_USER,
  DELETE_USER_FAILED,
  DELETE_USER_SUCCESS,
  EDIT_USER,
  EDIT_USER_FAILED,
  EDIT_USER_SUCCESS,
  GET_USERS,
  GET_USERS_FAILED,
  GET_USERS_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCESS,
  UPDATE_PROFILE_LOGO,
  UPDATE_PROFILE_LOGO_FAILED,
  UPDATE_PROFILE_LOGO_SUCCESS,
  GET_PARTIAL_USER_SUCCESS,
  GET_PARTIAL_USER_FAILED,
  GET_PARTIAL_USER,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_FAILED,
  GET_COMPANIES,
  DELETE_COMPANIES_DATA_SUCCESS,
  DELETE_COMPANIES_DATA_FAILED,
  DELETE_COMPANIES_DATA,
  UPDATE_SIGNATURE_SUCCESS,
  UPDATE_SIGNATURE_FAILED,
  UPDATE_SIGNATURE,
} from "../types/API/userTypes";
import {
  ADD_ADDRESS,
  ADD_ADDRESS_FAILED,
  ADD_ADDRESS_SUCCESS,
  DELETE_ADDRESS,
  DELETE_ADDRESS_FAILED,
  DELETE_ADDRESS_SUCCESS,
  EDIT_ADDRESS,
  EDIT_ADDRESS_FAILED,
  EDIT_ADDRESS_SUCCESS,
  GET_ADDRESS,
  GET_ADDRESS_FAILED,
  GET_ADDRESS_SUCCESS,
  SET_DEFAULT_ADDRESS,
  SET_DEFAULT_ADDRESS_FAILED,
  SET_DEFAULT_ADDRESS_SUCCESS,
} from "../types/API/addressTypes";
import {
  ADD_ITEM,
  ADD_ITEM_FAILED,
  ADD_ITEM_SUCCESS,
  BULK_DELETE_ITEM,
  BULK_DELETE_ITEM_FAILED,
  BULK_DELETE_ITEM_SUCCESS,
  BULK_EDIT_ITEM,
  BULK_EDIT_ITEM_FAILED,
  BULK_EDIT_ITEM_SUCCESS,
  BULK_RECONCILATION_ITEM,
  BULK_RECONCILATION_ITEM_FAILED,
  BULK_RECONCILATION_ITEM_SUCCESS,
  BULK_STOCK_UPDATE,
  BULK_STOCK_UPDATE_FAILED,
  BULK_STOCK_UPDATE_SUCCESS,
  BULK_UPLOAD_ALTERNATE_UNIT,
  BULK_UPLOAD_ALTERNATE_UNIT_FAILED,
  BULK_UPLOAD_ALTERNATE_UNIT_SUCCESS,
  BULK_UPLOAD_ITEM,
  BULK_UPLOAD_ITEM_FAILED,
  BULK_UPLOAD_ITEM_SUCCESS,
  DELETE_ITEM,
  DELETE_ITEM_FAILED,
  DELETE_ITEM_SUCCESS,
  EDIT_ITEM,
  EDIT_ITEM_FAILED,
  EDIT_ITEM_SUCCESS,
  GET_ITEMS,
  GET_ITEMS_PAGINATED,
  GET_ITEMS_PAGINATED_FAILED,
  GET_ITEMS_PAGINATED_SUCCESS,
  GET_ITEMS_FAILED,
  GET_ITEMS_SUCCESS,
  GET_LAST_UPDATED_PRICE,
  GET_LAST_UPDATED_PRICE_FAILED,
  GET_LAST_UPDATED_PRICE_SUCCESS,
} from "../types/API/itemTypes";
import {
  ADD_BUYER_SUPPLIER,
  ADD_BUYER_SUPPLIER_FAILED,
  ADD_BUYER_SUPPLIER_SUCCESS,
  BULK_DELETE_BUYER_SUPPLIER,
  BULK_DELETE_BUYER_SUPPLIER_FAILED,
  BULK_DELETE_BUYER_SUPPLIER_SUCCESS,
  BULK_UPLOAD_BUYER_SUPPLIER,
  BULK_UPLOAD_BUYER_SUPPLIER_FAILED,
  BULK_UPLOAD_BUYER_SUPPLIER_SUCCESS,
  DELETE_BUYER_SUPPLIER,
  DELETE_BUYER_SUPPLIER_FAILED,
  DELETE_BUYER_SUPPLIER_SUCCESS,
  EDIT_BUYER_SUPPLIER,
  EDIT_BUYER_SUPPLIER_FAILED,
  EDIT_BUYER_SUPPLIER_SUCCESS,
  GET_BUYER_SUPPLIER,
  GET_BUYER_SUPPLIER_FAILED,
  GET_BUYER_SUPPLIER_SUCCESS,
  GET_COMPANY_DETAILS_BY_GSTN,
  GET_COMPANY_DETAILS_BY_GSTN_FAILED,
  GET_COMPANY_DETAILS_BY_GSTN_SUCCESS,
} from "../types/API/buyerSupplier";
import {
  ADD_BANK_DETAIL,
  ADD_BANK_DETAIL_FAILED,
  ADD_BANK_DETAIL_SUCCESS,
  DELETE_BANK_DETAIL,
  DELETE_BANK_DETAIL_FAILED,
  DELETE_BANK_DETAIL_SUCCESS,
  EDIT_BANK_DETAIL,
  EDIT_BANK_DETAIL_FAILED,
  EDIT_BANK_DETAIL_SUCCESS,
  GET_BANK_DETAIL,
  GET_BANK_DETAIL_FAILED,
  GET_BANK_DETAIL_SUCCESS,
} from "../types/API/bankDetailType";
import {
  ADD_DOCUMENT_SERIES,
  ADD_DOCUMENT_SERIES_FAILED,
  ADD_DOCUMENT_SERIES_SUCCESS,
  DELETE_DOCUMENT_SERIES,
  DELETE_DOCUMENT_SERIES_FAILED,
  DELETE_DOCUMENT_SERIES_SUCCESS,
  EDIT_DOCUMENT_SERIES,
  EDIT_DOCUMENT_SERIES_FAILED,
  EDIT_DOCUMENT_SERIES_SUCCESS,
  GET_DOCUMENT_SERIES,
  GET_DOCUMENT_SERIES_FAILED,
  GET_DOCUMENT_SERIES_SUCCESS,
  SET_DEFAULT_SERIES,
  SET_DEFAULT_SERIES_FAILED,
  SET_DEFAULT_SERIES_SUCCESS,
  UPDATE_LAST_DOCUMENT_NUMBER,
  UPDATE_LAST_DOCUMENT_NUMBER_FAILED,
  UPDATE_LAST_DOCUMENT_NUMBER_SUCCESS,
} from "../types/API/documentSeriesType";
import {
  CREATE_DOCUMENT,
  CREATE_DOCUMENT_FAILED,
  CREATE_DOCUMENT_SUCCESS,


  GET_APPROVAL_HISTORY,
  GET_APPROVAL_HISTORY_SUCCESS,
  GET_APPROVAL_HISTORY_FAILED,


  CHANGE_APPROVAL_STATUS,
  CHANGE_APPROVAL_STATUS_SUCCESS,
  CHANGE_APPROVAL_STATUS_FAILED,


  GET_DOCUMENTS_BY_STATUS,
  GET_DOCUMENTS_BY_STATUS_SUCCESS,
  GET_DOCUMENTS_BY_STATUS_FAILED,

  DELETE_DOCUMENT,
  DELETE_DOCUMENT_FAILED,
  DELETE_DOCUMENT_SUCCESS,
  DISCARD_DOCUMENT,
  DISCARD_DOCUMENT_FAILED,
  DISCARD_DOCUMENT_SUCCESS,
  EDIT_DOCUMENT,
  EDIT_DOCUMENT_FAILED,
  EDIT_DOCUMENT_SUCCESS,
  GET_DOCUMENT_ITEMS,
  GET_DOCUMENT_ITEMS_FAILED,
  GET_DOCUMENT_ITEMS_SUCCESS,
  GET_DOCUMENTS,
  GET_DOCUMENTS_BY_ID,
  GET_DOCUMENTS_BY_ID_FAILED,
  GET_DOCUMENTS_BY_ID_SUCCESS,
  GET_DOCUMENTS_FAILED,
  GET_DOCUMENTS_SUCCESS,
  GET_SALES_DOCUMENTS_ITEMS,
  GET_SALES_DOCUMENTS_ITEMS_FAILED,
  GET_SALES_DOCUMENTS_ITEMS_SUCCESS,
  GET_SERVICE_CHALLAN_ITEMS,
  GET_SERVICE_CHALLAN_ITEMS_FAILED,
  GET_SERVICE_CHALLAN_ITEMS_SUCCESS,
  PREVIEW_DOCUMENT,
  PREVIEW_DOCUMENT_FAILED,
  PREVIEW_DOCUMENT_SUCCESS,
  SHORT_CLOSE_TRANSACTION,
  SHORT_CLOSE_TRANSACTION_FAILED,
  SHORT_CLOSE_TRANSACTION_SUCCESS,
  GET_TABLE_DOCUMENTS_SUCCESS,
  GET_TABLE_DOCUMENTS_FAILED,
  GET_TABLE_DOCUMENTS,
  CREATE_EINVOICE_SUCCESS,
  CREATE_EINVOICE_FAILED,
  CREATE_EINVOICE,
  CREATE_EWAYBILL_SUCCESS,
  CREATE_EWAYBILL_FAILED,
  CREATE_EWAYBILL,
  FETCH_CURRENT_DOC_SUCCESS,
  FETCH_CURRENT_DOC_FAILED,
  FETCH_CURRENT_DOC,
  EMAIL_DOCUMENT_SUCCESS,
  EMAIL_DOCUMENT_FAILED,
  EMAIL_DOCUMENT,
  CANCEL_EINVOICE_SUCCESS,
  CANCEL_EINVOICE_FAILED,
  CANCEL_EINVOICE,
  GET_CHALLAN_ITEMS_SUCCESS,
  GET_CHALLAN_ITEMS_FAILED,
  GET_CHALLAN_ITEMS,
  CREATE_EWAYBILL_FROM_EINVOICE_SUCCESS,
  CREATE_EWAYBILL_FROM_EINVOICE_FAILED,
  CREATE_EWAYBILL_FROM_EINVOICE,
  CANCEL_EWAYBILL,
  CANCEL_EWAYBILL_SUCCESS,
  CANCEL_EWAYBILL_FAILED,
  SAVE_RFQ_QUOTATION,
  SAVE_RFQ_QUOTATION_SUCCESS,
  SAVE_RFQ_QUOTATION_FAILED,
} from "../types/API/documents";
import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_FAILED,
  GET_NOTIFICATIONS_SUCCESS,
  NOTIFY,
  NOTIFY_FAILED,
  NOTIFY_SUCCESS,
} from "../types/API/notificationTypes";
import {
  GET_ACCOUNT_INFO,
  GET_ACCOUNT_INFO_FAILED,
  GET_ACCOUNT_INFO_SUCCESS,
  UPDATE_ACCOUNT_INFO,
  UPDATE_ACCOUNT_INFO_FAILED,
  UPDATE_ACCOUNT_INFO_SUCCESS,
} from "../types/API/accountInfoType";
import {
  GET_ALL_REJECT_STORE_ITEMS,
  GET_ALL_REJECT_STORE_ITEMS_FAILED,
  GET_ALL_REJECT_STORE_ITEMS_SUCCESS,
  STOCK_TRANSFER,
  STOCK_TRANSFER_FAILED,
  STOCK_TRANSFER_SUCCESS,
} from "../types/API/stockTransfer";
import {
  ADD_UOM,
  ADD_UOM_FAILED,
  ADD_UOM_SUCCESS,
  DELETE_UOM,
  DELETE_UOM_FAILED,
  DELETE_UOM_SUCCESS,
  EDIT_UOM,
  EDIT_UOM_FAILED,
  EDIT_UOM_SUCCESS,
  GET_UOM,
  GET_UOM_FAILED,
  GET_UOM_SUCCESS,
} from "../types/API/uomType";
import {
  ITEM_STOCK_TRANSFER_HISTORY,
  ITEM_STOCK_TRANSFER_HISTORY_FAILED,
  ITEM_STOCK_TRANSFER_HISTORY_SUCCESS,
  STOCK_TRANSFER_HISTORY,
  STOCK_TRANSFER_HISTORY_FAILED,
  STOCK_TRANSFER_HISTORY_SUCCESS,
} from "../types/API/transferHistory";
import {
  ADD_CATEGORY,
  ADD_CATEGORY_FAILED,
  ADD_CATEGORY_SUCCESS,
  DELETE_CATEGORY,
  DELETE_CATEGORY_FAILED,
  DELETE_CATEGORY_SUCCESS,
  EDIT_CATEGORY,
  EDIT_CATEGORY_FAILED,
  EDIT_CATEGORY_SUCCESS,
  GET_CATEGORY,
  GET_CATEGORY_FAILED,
  GET_CATEGORY_SUCCESS,
} from "../types/API/categoryType";
import {
  STOCK_UPDATE,
  STOCK_UPDATE_FAILED,
  STOCK_UPDATE_SUCCESS,
} from "../types/API/stockUpdate";
import {
  STOCK_RECONCILE,
  STOCK_RECONCILE_FAILED,
  STOCK_RECONCILE_SUCCESS,
} from "../types/API/reconcileAndUploadType";
import {
  ADD_PAYMENT_TERMS,
  ADD_PAYMENT_TERMS_FAILED,
  ADD_PAYMENT_TERMS_SUCCESS,
  DELETE_PAYMENT_TERMS,
  DELETE_PAYMENT_TERMS_FAILED,
  DELETE_PAYMENT_TERMS_SUCCESS,
  EDIT_PAYMENT_TERMS,
  EDIT_PAYMENT_TERMS_FAILED,
  EDIT_PAYMENT_TERMS_SUCCESS,
  GET_PAYMENT_TERMS,
  GET_PAYMENT_TERMS_FAILED,
  GET_PAYMENT_TERMS_SUCCESS,
} from "../types/API/paymentTerm";
import {
  ADD_LOGISTIC_DETAILS,
  ADD_LOGISTIC_DETAILS_FAILED,
  ADD_LOGISTIC_DETAILS_SUCCESS,
  DELETE_LOGISTIC_DETAILS,
  DELETE_LOGISTIC_DETAILS_FAILED,
  DELETE_LOGISTIC_DETAILS_SUCCESS,
  EDIT_LOGISTIC_DETAILS,
  EDIT_LOGISTIC_DETAILS_FAILED,
  EDIT_LOGISTIC_DETAILS_SUCCESS,
  GET_LOGISTIC_DETAILS,
  GET_LOGISTIC_DETAILS_FAILED,
  GET_LOGISTIC_DETAILS_SUCCESS,
} from "../types/API/logisticDetails";
import {
  ADD_TRANSPORTER_DETAILS,
  ADD_TRANSPORTER_DETAILS_FAILED,
  ADD_TRANSPORTER_DETAILS_SUCCESS,
  DELETE_TRANSPORTER_DETAILS,
  DELETE_TRANSPORTER_DETAILS_FAILED,
  DELETE_TRANSPORTER_DETAILS_SUCCESS,
  EDIT_TRANSPORTER_DETAILS,
  EDIT_TRANSPORTER_DETAILS_FAILED,
  EDIT_TRANSPORTER_DETAILS_SUCCESS,
  GET_TRANSPORTER_DETAILS,
  GET_TRANSPORTER_DETAILS_FAILED,
  GET_TRANSPORTER_DETAILS_SUCCESS,
} from "../types/API/transporterDetails";
import {
  ADD_TERMS_CONDITION,
  ADD_TERMS_CONDITION_FAILED,
  ADD_TERMS_CONDITION_SUCCESS,
  DELETE_TERMS_CONDITION,
  DELETE_TERMS_CONDITION_FAILED,
  DELETE_TERMS_CONDITION_SUCCESS,
  EDIT_TERMS_CONDITION,
  EDIT_TERMS_CONDITION_FAILED,
  EDIT_TERMS_CONDITION_SUCCESS,
  GET_TERMS_CONDITION,
  GET_TERMS_CONDITION_FAILED,
  GET_TERMS_CONDITION_SUCCESS,
} from "../types/API/termsConditions";
import {
  ADD_CUSTOM_FIELDS,
  ADD_CUSTOM_FIELDS_FAILED,
  ADD_CUSTOM_FIELDS_SUCCESS,
  DELETE_CUSTOM_FIELDS,
  DELETE_CUSTOM_FIELDS_FAILED,
  DELETE_CUSTOM_FIELDS_SUCCESS,
  EDIT_CUSTOM_FIELD,
  EDIT_CUSTOM_FIELD_FAILED,
  EDIT_CUSTOM_FIELD_SUCCESS,
  EDIT_CUSTOM_FIELDS,
  EDIT_CUSTOM_FIELDS_FAILED,
  EDIT_CUSTOM_FIELDS_SUCCESS,
  EDIT_PERMISSIONS,
  EDIT_PERMISSIONS_FAILED,
  EDIT_PERMISSIONS_SUCCESS,
  GET_CUSTOM_FIELDS,
  GET_CUSTOM_FIELDS_FAILED,
  GET_CUSTOM_FIELDS_SUCCESS,
} from "../types/API/customFields";
import {
  ADD_CUSTOM_FORMS,
  ADD_CUSTOM_FORMS_FAILED,
  ADD_CUSTOM_FORMS_SUCCESS,
  DELETE_CUSTOM_FORMS,
  DELETE_CUSTOM_FORMS_FAILED,
  DELETE_CUSTOM_FORMS_SUCCESS,
  EDIT_CUSTOM_FORMS,
  EDIT_CUSTOM_FORMS_FAILED,
  EDIT_CUSTOM_FORMS_SUCCESS,
  GET_CUSTOM_FORMS,
  GET_CUSTOM_FORMS_FAILED,
  GET_CUSTOM_FORMS_SUCCESS,
} from "../types/API/customForms";

import {
  ADD_CONTACT_US,
  ADD_CONTACT_US_FAILED,
  ADD_CONTACT_US_SUCCESS,
  GET_CONTACT_US,
  GET_CONTACT_US_FAILED,
  GET_CONTACT_US_SUCCESS,
} from "../types/API/contactUsType";

import {
  ADD_REQUEST_DEMO_QUERY_DATA,
  ADD_REQUEST_DEMO_QUERY_DATA_FAILED,
  ADD_REQUEST_DEMO_QUERY_DATA_SUCCESS,
  GET_REQUEST_DEMO_QUERY_DATA,
  GET_REQUEST_DEMO_QUERY_DATA_FAILED,
  GET_REQUEST_DEMO_QUERY_DATA_SUCCESS,
} from "../types/API/demoQueryType";
import { ADD_NEWS_LETTERS, ADD_NEWS_LETTERS_FAILED, ADD_NEWS_LETTERS_SUCCESS, GET_NEWS_LETTERS, GET_NEWS_LETTERS_FAILED, GET_NEWS_LETTERS_SUCCESS, UNSUBSCRIBE_NEWS_LETTERS, UNSUBSCRIBE_NEWS_LETTERS_FAILED, UNSUBSCRIBE_NEWS_LETTERS_SUCCESS } from "../types/API/newsLetters";
import { FAST_MOVING_SLOW_MOVING_ITEMS, FAST_MOVING_SLOW_MOVING_ITEMS_FAILURE, FAST_MOVING_SLOW_MOVING_ITEMS_SUCCESS, GET_CATEGORY_WISE_ITEMS, GET_CATEGORY_WISE_ITEMS_FAILURE, GET_CATEGORY_WISE_ITEMS_SUCCESS, GET_COMPANIES_COUNT, GET_COMPANIES_COUNT_FAILURE, GET_COMPANIES_COUNT_SUCCESS, GET_DASHBOARD_DATA, GET_DASHBOARD_DATA_FAILURE, GET_DASHBOARD_DATA_SUCCESS, GET_DOCUMENTS_COUNT, GET_DOCUMENTS_COUNT_FAILURE, GET_DOCUMENTS_COUNT_SUCCESS, GET_INVOICE_SUMMARY, GET_INVOICE_SUMMARY_FAILURE, GET_INVOICE_SUMMARY_SUCCESS, GET_ITEMS_COUNT, GET_ITEMS_COUNT_FAILURE, GET_ITEMS_COUNT_SUCCESS, GET_ITEMS_SALES_SUMMARY, GET_ITEMS_SALES_SUMMARY_FAILURE, GET_ITEMS_SALES_SUMMARY_SUCCESS, GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION, GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_FAILURE, GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_SUCCESS, GET_STORE_WISE_ITEMS, GET_STORE_WISE_ITEMS_FAILURE, GET_STORE_WISE_ITEMS_SUCCESS, GET_STORES_COUNT, GET_STORES_COUNT_FAILURE, GET_STORES_COUNT_SUCCESS, GET_USERS_COUNT, GET_USERS_COUNT_FAILURE, GET_USERS_COUNT_SUCCESS, ON_TIME_DELAY_PRODUCTION, ON_TIME_DELAY_PRODUCTION_FAILURE, ON_TIME_DELAY_PRODUCTION_SUCCESS, PREDICT_NEXT_VALUE, PREDICT_NEXT_VALUE_FAILURE, PREDICT_NEXT_VALUE_SUCCESS, PREDICT_SALES, PREDICT_SALES_FAILURE, PREDICT_SALES_SUCCESS, STOCK_AGEING, STOCK_AGEING_FAILURE, STOCK_AGEING_SUCCESS, STOCK_LEVEL_ANALYSIS, STOCK_LEVEL_ANALYSIS_FAILURE, STOCK_LEVEL_ANALYSIS_SUCCESS, WORK_ORDER_STATUS, WORK_ORDER_STATUS_FAILURE, WORK_ORDER_STATUS_SUCCESS, GET_SALES_DASHBOARD_DETAILS, GET_SALES_DASHBOARD_DETAILS_SUCCESS, GET_SALES_DASHBOARD_DETAILS_FAILURE } from "../types/API/dashboardType";
import { REPORT_COLUMNS_PREFRENCE, REPORT_COLUMNS_PREFRENCE_FAILED, REPORT_COLUMNS_PREFRENCE_SUCCESS } from "../types/API/reportColumns";
import { ADD_INVENTORY_SERVICES, ADD_INVENTORY_SERVICES_FAILED, ADD_INVENTORY_SERVICES_SUCCESS, DELETE_INVENTORY_SERVICES, DELETE_INVENTORY_SERVICES_FAILED, DELETE_INVENTORY_SERVICES_SUCCESS, EDIT_INVENTORY_SERVICES, EDIT_INVENTORY_SERVICES_FAILED, EDIT_INVENTORY_SERVICES_SUCCESS, GET_INVENTORY_SERVICES, GET_INVENTORY_SERVICES_FAILED, GET_INVENTORY_SERVICES_SUCCESS } from "../types/API/inventoryServices";
import { CREATE_SELECT_BATCHITEMS, CREATE_SELECT_BATCHITEMS_FAILED, CREATE_SELECT_BATCHITEMS_SUCCESS, GET_BATCHITEMS, GET_BATCHITEMS_FAILED, GET_BATCHITEMS_SUCCESS } from "../types/API/batchItemsType";
import { UPDATE_BATCHITEMS, UPDATE_BATCHITEMS_FAILED, UPDATE_BATCHITEMS_SUCCESS } from "../types/API/batchItemsType";
import { CREATE_BATCHITEMS, CREATE_BATCHITEMS_FAILED, CREATE_BATCHITEMS_SUCCESS } from "../types/API/batchItemsType";
import { CREATE_PRODUCTION_PROCESS, CREATE_PRODUCTION_PROCESS_FAILED, CREATE_PRODUCTION_PROCESS_SUCCESS, DELETE_PRODUCTION_PROCESS, DELETE_PRODUCTION_PROCESS_FAILED, DELETE_PRODUCTION_PROCESS_SUCCESS, GET_PRODUCTION_PROCESS, GET_PRODUCTION_PROCESS_FAILED, GET_PRODUCTION_PROCESS_SUCCESS, GET_PRODUCTION_PROCESS_BY_ID, GET_PRODUCTION_PROCESS_BY_ID_FAILED, GET_PRODUCTION_PROCESS_BY_ID_SUCCESS, UPDATE_PRODUCTION_PROCESS, UPDATE_PRODUCTION_PROCESS_FAILED, UPDATE_PRODUCTION_PROCESS_SUCCESS } from "../types/API/productionProcess";
import { BULK_UPLOAD_BOM, BULK_UPLOAD_BOM_FAILED, BULK_UPLOAD_BOM_SUCCESS, CREATE_BOM_DETAILS, CREATE_BOM_DETAILS_FAILED, CREATE_BOM_DETAILS_SUCCESS, DELETE_BILL_OF_MATERIALS, DELETE_BILL_OF_MATERIALS_FAILED, DELETE_BILL_OF_MATERIALS_SUCCESS, DELETE_BOM_DETAILS, DELETE_BOM_DETAILS_FAILED, DELETE_BOM_DETAILS_SUCCESS, DUPLICATE_BOM, DUPLICATE_BOM_FAILED, DUPLICATE_BOM_SUCCESS, EDIT_BILL_OF_MATERIALS, EDIT_BILL_OF_MATERIALS_FAILED, EDIT_BILL_OF_MATERIALS_SUCCESS, GET_ALL_BOM_DETAILS, GET_ALL_BOM_DETAILS_FAILED, GET_ALL_BOM_DETAILS_SUCCESS, GET_BOM_DETAILS, GET_BOM_DETAILS_BY_ID, GET_BOM_DETAILS_BY_ID_FAILED, GET_BOM_DETAILS_BY_ID_SUCCESS, GET_BOM_DETAILS_FAILED, GET_BOM_DETAILS_SUCCESS, GET_ITEMS_BOM_DETAILS, GET_ITEMS_BOM_DETAILS_FAILED, GET_ITEMS_BOM_DETAILS_SUCCESS, UPDATE_BOM_DETAILS, UPDATE_BOM_DETAILS_FAILED, UPDATE_BOM_DETAILS_SUCCESS } from "../types/API/bomDetails";
import { CREATE_BOM_PRODUCTION_PROCESS, CREATE_BOM_PRODUCTION_PROCESS_FAILED, CREATE_BOM_PRODUCTION_PROCESS_SUCCESS, DELETE_BOM_PRODUCTION_PROCESS, DELETE_BOM_PRODUCTION_PROCESS_FAILED, DELETE_BOM_PRODUCTION_PROCESS_SUCCESS, GET_BOM_PRODUCTION_PROCESS, GET_BOM_PRODUCTION_PROCESS_FAILED, GET_BOM_PRODUCTION_PROCESS_SUCCESS, UPDATE_BOM_PRODUCTION_PROCESS, UPDATE_BOM_PRODUCTION_PROCESS_FAILED, UPDATE_BOM_PRODUCTION_PROCESS_SUCCESS } from "../types/API/bomProductionProcess";
import { ADD_BOM_FINISHED_GOODS, ADD_BOM_FINISHED_GOODS_FAILED, ADD_BOM_FINISHED_GOODS_SUCCESS, DELETE_BOM_FINISHED_GOODS, DELETE_BOM_FINISHED_GOODS_FAILED, DELETE_BOM_FINISHED_GOODS_SUCCESS, GET_BOM_FINISHED_GOODS, GET_BOM_FINISHED_GOODS_FAILED, GET_BOM_FINISHED_GOODS_SUCCESS, UPDATE_BOM_FINISHED_GOODS, UPDATE_BOM_FINISHED_GOODS_FAILED, UPDATE_BOM_FINISHED_GOODS_SUCCESS } from "../types/API/bomFinishedGoods";
import { ADD_BOM_RAW_MATERIALS, ADD_BOM_RAW_MATERIALS_FAILED, ADD_BOM_RAW_MATERIALS_SUCCESS, DELETE_BOM_RAW_MATERIALS, DELETE_BOM_RAW_MATERIALS_FAILED, DELETE_BOM_RAW_MATERIALS_SUCCESS, GET_BOM_RAW_MATERIALS, GET_BOM_RAW_MATERIALS_FAILED, GET_BOM_RAW_MATERIALS_SUCCESS, ISSUE_RAW_MATERIAL, ISSUE_RAW_MATERIAL_FAILED, ISSUE_RAW_MATERIAL_SUCCESS, LINK_BOM, LINK_BOM_FAILED, LINK_BOM_SUCCESS, UNLINK_BOM, UNLINK_BOM_FAILED, UNLINK_BOM_SUCCESS, UPDATE_BOM_RAW_MATERIALS, UPDATE_BOM_RAW_MATERIALS_FAILED, UPDATE_BOM_RAW_MATERIALS_SUCCESS } from "../types/API/bomRawMaterials";
import { ADD_BOM_SCRAP_LOG, ADD_BOM_SCRAP_LOG_FAILED, ADD_BOM_SCRAP_LOG_SUCCESS, DELETE_BOM_SCRAP_LOG, DELETE_BOM_SCRAP_LOG_FAILED, DELETE_BOM_SCRAP_LOG_SUCCESS, GET_BOM_SCRAP_LOG, GET_BOM_SCRAP_LOG_FAILED, GET_BOM_SCRAP_LOG_SUCCESS, UPDATE_BOM_SCRAP_LOG, UPDATE_BOM_SCRAP_LOG_FAILED, UPDATE_BOM_SCRAP_LOG_SUCCESS } from "../types/API/bomScrapLogs";
import { ADD_BOM_ADDITIONAL_CHARGES, ADD_BOM_ADDITIONAL_CHARGES_FAILED, ADD_BOM_ADDITIONAL_CHARGES_SUCCESS, DELETE_BOM_ADDITIONAL_CHARGES, DELETE_BOM_ADDITIONAL_CHARGES_FAILED, DELETE_BOM_ADDITIONAL_CHARGES_SUCCESS, GET_BOM_ADDITIONAL_CHARGES, GET_BOM_ADDITIONAL_CHARGES_FAILED, GET_BOM_ADDITIONAL_CHARGES_SUCCESS, UPDATE_BOM_ADDITIONAL_CHARGES, UPDATE_BOM_ADDITIONAL_CHARGES_FAILED, UPDATE_BOM_ADDITIONAL_CHARGES_SUCCESS } from "../types/API/bomAdditionalCharges";
import { BOM_BASED_MATERIAL_PLANNING, BOM_BASED_MATERIAL_PLANNING_FAILED, BOM_BASED_MATERIAL_PLANNING_SUCCESS, BULK_ISSUE, BULK_ISSUE_FAILED, BULK_ISSUE_SUCCESS, DELETE_LOGS, DELETE_LOGS_FAILED, DELETE_LOGS_SUCCESS, DISCARD_PRODUCTION, DISCARD_PRODUCTION_FAILED, DISCARD_PRODUCTION_SUCCESS, GET_ALL_PRODUCTIONS, GET_ALL_PRODUCTIONS_FAILED, GET_ALL_PRODUCTIONS_SUCCESS, GET_BULK_PRODUCTION, GET_BULK_PRODUCTION_FAILED, GET_BULK_PRODUCTION_SUCCESS, GET_BULK_PRODUCTIONS, GET_BULK_PRODUCTIONS_FAILED, GET_BULK_PRODUCTIONS_SUCCESS, GET_PRODUCTION, GET_PRODUCTION_BY_ID, GET_PRODUCTION_BY_ID_FAILED, GET_PRODUCTION_BY_ID_SUCCESS, GET_PRODUCTION_FAILED, GET_PRODUCTION_SUCCESS, GET_PRODUCTIONS_BY_COMPANY_ID, GET_PRODUCTIONS_BY_COMPANY_ID_FAILED, GET_PRODUCTIONS_BY_COMPANY_ID_SUCCESS, GET_REMAINING_PRODUCTION, GET_REMAINING_PRODUCTION_FAILED, GET_REMAINING_PRODUCTION_SUCCESS, MATERIAL_PLANNING, MATERIAL_PLANNING_FAILED, MATERIAL_PLANNING_SUCCESS, MIN_STOCK_MATERIAL_PLANNING, MIN_STOCK_MATERIAL_PLANNING_FAILED, MIN_STOCK_MATERIAL_PLANNING_SUCCESS, PRODUCTION_BASED_MATERIAL_PLANNING, PRODUCTION_BASED_MATERIAL_PLANNING_FAILED, PRODUCTION_BASED_MATERIAL_PLANNING_SUCCESS, REMOVE_ROWS, REMOVE_ROWS_FAILED, REMOVE_ROWS_SUCCESS, RETURN_RAW_MATERIAL, RETURN_RAW_MATERIAL_FAILED, RETURN_RAW_MATERIAL_SUCCESS, SAVE_FINISHED_GOODS, SAVE_FINISHED_GOODS_FAILED, SAVE_FINISHED_GOODS_SUCCESS, SAVE_PRODUCTION, SAVE_PRODUCTION_FAILED, SAVE_PRODUCTION_SUCCESS, SAVE_REWORK, SAVE_REWORK_FAILED, SAVE_REWORK_SUCCESS, START_BULK_PRODUCTION, START_BULK_PRODUCTION_FAILED, START_BULK_PRODUCTION_SUCCESS, START_PRODUCTION, START_PRODUCTION_FAILED, START_PRODUCTION_SUCCESS, UPDATE_COST, UPDATE_COST_FAILED, UPDATE_COST_SUCCESS, UPDATE_PROCESS, UPDATE_PROCESS_FAILED, UPDATE_PROCESS_SUCCESS, UPDATE_PRODUCTION_STATUS, UPDATE_PRODUCTION_STATUS_FAILED, UPDATE_PRODUCTION_STATUS_SUCCESS, UPDATE_SCRAP_LOGS, UPDATE_SCRAP_LOGS_FAILED, UPDATE_SCRAP_LOGS_SUCCESS, UPDATE_START_DATE, UPDATE_START_DATE_FAILED, UPDATE_START_DATE_SUCCESS, UPDATE_TABLE, UPDATE_TABLE_FAILED, UPDATE_TABLE_SUCCESS, VIEW_PRODUCTION_HISTORY, VIEW_PRODUCTION_HISTORY_FAILED, VIEW_PRODUCTION_HISTORY_SUCCESS } from "../types/API/production";
import { ADD_BOM_SERIES, ADD_BOM_SERIES_FAILED, ADD_BOM_SERIES_SUCCESS, DELETE_BOM_SERIES, DELETE_BOM_SERIES_FAILED, DELETE_BOM_SERIES_SUCCESS, EDIT_BOM_SERIES, EDIT_BOM_SERIES_FAILED, EDIT_BOM_SERIES_SUCCESS, GET_BOM_SERIES, GET_BOM_SERIES_FAILED, GET_BOM_SERIES_SUCCESS, SET_DEFAULT_BOM_SERIES, SET_DEFAULT_BOM_SERIES_FAILED, SET_DEFAULT_BOM_SERIES_SUCCESS, UPDATE_LAST_BOM_NUMBER, UPDATE_LAST_BOM_NUMBER_FAILED, UPDATE_LAST_BOM_NUMBER_SUCCESS } from "../types/API/bomSeries";
import { ADD_LOG_PAYMENTS, ADD_LOG_PAYMENTS_FAILED, ADD_LOG_PAYMENTS_SUCCESS, DELETE_LOG_PAYMENTS, DELETE_LOG_PAYMENTS_FAILED, DELETE_LOG_PAYMENTS_SUCCESS, GET_LOG_PAYMENT_BY_ID, GET_LOG_PAYMENT_BY_ID_FAILED, GET_LOG_PAYMENT_BY_ID_SUCCESS, GET_LOG_PAYMENTS, GET_LOG_PAYMENTS_FAILED, GET_LOG_PAYMENTS_SUCCESS, UPDATE_LOG_PAYMENTS, UPDATE_LOG_PAYMENTS_FAILED, UPDATE_LOG_PAYMENTS_SUCCESS } from "../types/API/logPayments";
import { ADD_LOG_TDS, ADD_LOG_TDS_FAILED, ADD_LOG_TDS_SUCCESS, DELETE_LOG_TDS, DELETE_LOG_TDS_FAILED, DELETE_LOG_TDS_SUCCESS, GET_LOG_TDS, GET_LOG_TDS_BY_ID, GET_LOG_TDS_BY_ID_FAILED, GET_LOG_TDS_BY_ID_SUCCESS, GET_LOG_TDS_FAILED, GET_LOG_TDS_SUCCESS, UPDATE_LOG_TDS, UPDATE_LOG_TDS_FAILED, UPDATE_LOG_TDS_SUCCESS } from "../types/API/logTDS";
import { ADD_ITEM_SERIES, ADD_ITEM_SERIES_FAILED, ADD_ITEM_SERIES_SUCCESS, DELETE_ITEM_SERIES, DELETE_ITEM_SERIES_FAILED, DELETE_ITEM_SERIES_SUCCESS, EDIT_ITEM_SERIES, EDIT_ITEM_SERIES_FAILED, EDIT_ITEM_SERIES_SUCCESS, GET_ITEM_SERIES, GET_ITEM_SERIES_FAILED, GET_ITEM_SERIES_SUCCESS, SET_DEFAULT_ITEM_SERIES, SET_DEFAULT_ITEM_SERIES_FAILED, SET_DEFAULT_ITEM_SERIES_SUCCESS, UPDATE_LAST_ITEM_NUMBER, UPDATE_LAST_ITEM_NUMBER_FAILED, UPDATE_LAST_ITEM_NUMBER_SUCCESS } from "../types/API/itemSeries";
import { GET_REPORTS, GET_REPORTS_FAILED, GET_REPORTS_SUCCESS } from "../types/API/reportTypes";
import { GET_SETTING, GET_SETTING_FAILED, GET_SETTING_SUCCESS, UPDATE_SETTING, UPDATE_SETTING_FAILED, UPDATE_SETTING_SUCCESS } from "../types/API/settingTypes";
import { APPROVED_DOCUMENT, APPROVED_DOCUMENT_FAILED, APPROVED_DOCUMENT_SUCCESS, DELETE_APPROVAL_PERMISSION, DELETE_APPROVAL_PERMISSION_FAILED, DELETE_APPROVAL_PERMISSION_SUCCESS, GET_APPROVAL_PERMISSION, GET_APPROVAL_PERMISSION_FAILED, GET_APPROVAL_PERMISSION_SUCCESS, SET_APPROVAL_PERMISSION, SET_APPROVAL_PERMISSION_FAILED, SET_APPROVAL_PERMISSION_SUCCESS } from "../types/API/documentApprovaltype";
import { ACCEPT_REJECT_APPROVAL, ACCEPT_REJECT_APPROVAL_FAILED, ACCEPT_REJECT_APPROVAL_SUCCESS, GET_INVENTORY_APPROVAL, GET_INVENTORY_APPROVAL_BY_ID, GET_INVENTORY_APPROVAL_BY_ID_FAILED, GET_INVENTORY_APPROVAL_BY_ID_SUCCESS, GET_INVENTORY_APPROVAL_FAILED, GET_INVENTORY_APPROVAL_SUCCESS } from "../types/API/inventoryApprovalType";
import {
  ACCEPT_REJECT_BOM_APPROVAL,
  ACCEPT_REJECT_BOM_APPROVAL_FAILED,
  ACCEPT_REJECT_BOM_APPROVAL_SUCCESS,
  DELETE_BOM_APPROVAL_PERMISSION,
  DELETE_BOM_APPROVAL_PERMISSION_FAILED,
  DELETE_BOM_APPROVAL_PERMISSION_SUCCESS,
  GET_BOM_APPROVAL_BY_ID,
  GET_BOM_APPROVAL_BY_ID_FAILED,
  GET_BOM_APPROVAL_BY_ID_SUCCESS,
  GET_BOM_APPROVAL_PERMISSION,
  GET_BOM_APPROVAL_PERMISSION_FAILED,
  GET_BOM_APPROVAL_PERMISSION_SUCCESS,
  GET_BOM_APPROVALS,
  GET_BOM_APPROVALS_FAILED,
  GET_BOM_APPROVALS_SUCCESS,
  SET_BOM_APPROVAL_PERMISSION,
  SET_BOM_APPROVAL_PERMISSION_FAILED,
  SET_BOM_APPROVAL_PERMISSION_SUCCESS
} from "../types/API/bomApprovalType";
import { ADD_LABEL, ADD_LABEL_FAILED, ADD_LABEL_SUCCESS, ASSIGN_LABELS, ASSIGN_LABELS_FAILED, ASSIGN_LABELS_SUCCESS, DELETE_LABEL, DELETE_LABEL_FAILED, DELETE_LABEL_SUCCESS, EDIT_LABEL, EDIT_LABEL_FAILED, EDIT_LABEL_SUCCESS, GET_LABELS, GET_LABELS_FAILED, GET_LABELS_SUCCESS, REMOVE_LABEL, REMOVE_LABEL_FAILED, REMOVE_LABEL_SUCCESS } from "../types/API/labelTypes";
import { CREATE_EINVOICE_CREDENTIAL, CREATE_EINVOICE_CREDENTIAL_FAILED, CREATE_EINVOICE_CREDENTIAL_SUCCESS, DELETE_EINVOICE_CREDENTIAL, DELETE_EINVOICE_CREDENTIAL_FAILED, DELETE_EINVOICE_CREDENTIAL_SUCCESS, GET_EINVOICE_CREDENTIAL, GET_EINVOICE_CREDENTIAL_FAILED, GET_EINVOICE_CREDENTIAL_SUCCESS, UPDATE_EINVOICE_CREDENTIAL, UPDATE_EINVOICE_CREDENTIAL_FAILED, UPDATE_EINVOICE_CREDENTIAL_SUCCESS } from "../types/API/eInvoiceCredentialType";
import { CREATE_EMAIL_CREDENTIAL, CREATE_EMAIL_CREDENTIAL_FAILED, CREATE_EMAIL_CREDENTIAL_SUCCESS, DELETE_EMAIL_CREDENTIAL, DELETE_EMAIL_CREDENTIAL_FAILED, DELETE_EMAIL_CREDENTIAL_SUCCESS, GET_EMAIL_CREDENTIAL, GET_EMAIL_CREDENTIAL_FAILED, GET_EMAIL_CREDENTIAL_SUCCESS, UPDATE_EMAIL_CREDENTIAL, UPDATE_EMAIL_CREDENTIAL_FAILED, UPDATE_EMAIL_CREDENTIAL_SUCCESS } from "../types/API/emailCredentialType";
import { COMPLETIONS, COMPLETIONS_FAILED, COMPLETIONS_SUCCESS, REPORTS, REPORTS_FAILED, REPORTS_SUCCESS } from "../types/API/amyTypes";
import { ADD_COLUMNS, ADD_COLUMNS_FAILED, ADD_COLUMNS_SUCCESS, DELETE_COLUMNS, DELETE_COLUMNS_FAILED, DELETE_COLUMNS_SUCCESS, EDIT_COLUMNS, EDIT_COLUMNS_FAILED, EDIT_COLUMNS_SUCCESS, GET_COLUMNS, GET_COLUMNS_FAILED, GET_COLUMNS_SUCCESS } from "../types/API/showHideColumnsType";
import { CREATE_GATE_ENTRY, CREATE_GATE_ENTRY_FAILED, CREATE_GATE_ENTRY_SUCCESS, GET_ALL_GATE_ENTRIES, GET_ALL_GATE_ENTRIES_FAILED, GET_ALL_GATE_ENTRIES_SUCCESS, GET_GATE_ENTRIES_BY_ID, GET_GATE_ENTRIES_BY_ID_FAILED, GET_GATE_ENTRIES_BY_ID_SUCCESS, UPDATE_GATE_ENTRY, UPDATE_GATE_ENTRY_FAILED, UPDATE_GATE_ENTRY_SUCCESS } from "../types/API/gateEntry";
import {
  GET_PACKAGING_MASTER,
  GET_PACKAGING_MASTER_SUCCESS,
  GET_PACKAGING_MASTER_FAILED,
  ADD_PACKAGING_MASTER,
  ADD_PACKAGING_MASTER_SUCCESS,
  ADD_PACKAGING_MASTER_FAILED,
  EDIT_PACKAGING_MASTER,
  EDIT_PACKAGING_MASTER_SUCCESS,
  EDIT_PACKAGING_MASTER_FAILED,
  DELETE_PACKAGING_MASTER,
  DELETE_PACKAGING_MASTER_SUCCESS,
  DELETE_PACKAGING_MASTER_FAILED,
} from "../types/API/packagingMasterType";
import {
  GET_ITEM_MAPPING,
  GET_ITEM_MAPPING_SUCCESS,
  GET_ITEM_MAPPING_FAILED,
  ADD_ITEM_MAPPING,
  ADD_ITEM_MAPPING_SUCCESS,
  ADD_ITEM_MAPPING_FAILED,
  EDIT_ITEM_MAPPING,
  EDIT_ITEM_MAPPING_SUCCESS,
  EDIT_ITEM_MAPPING_FAILED,
  DELETE_ITEM_MAPPING,
  DELETE_ITEM_MAPPING_SUCCESS,
  DELETE_ITEM_MAPPING_FAILED,
} from "../types/API/itemMappingType";

function getApiWorker(endpoint) {
  const url = process.env.REACT_APP_API_URL + "/" + endpoint;
  console.log(process.env.REACT_APP_API_URL);
  return fetch(url, {
    headers: new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
    method: AppConstants.API_METHOD.GET,
  }).then((response) => {
    if (!response.ok) {
      const error = new Error(response.statusText);
      throw error;
    }
    return response.json();
  });
}

function postApiWorker(endpoint, requestBody, isMultipart = false) {
  const url = process.env.REACT_APP_API_URL + "/" + endpoint;

  // No need to manually set 'Content-Type' for multipart
  const headers = isMultipart
    ? {} // Browser will set it automatically for FormData
    : {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

  // Prepare body conditionally based on isMultipart
  const body = isMultipart ? requestBody : JSON.stringify(requestBody);

  return fetch(url, {
    headers: new Headers(headers),
    method: AppConstants.API_METHOD.POST,
    body: body,
  }).then(async (response) => {
    if (response.status === 409) {
      return response.json().then((errorResponse) => {
        const conflictError = new Error(
          errorResponse.message ||
          "Conflict: Resource already exists or another conflict occurred."
        );
        conflictError.status = 409;
        conflictError.message = errorResponse.message;
        throw conflictError;
      });
    }

    if (!response.ok) {
      throw response
    }

    return response.json();
  });
}

function* login(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "authentication/login",
      requestBody.payload
    );
    console.log(jwtDecode(response.token));
    yield put({
      type: LOGIN_USER_SUCCESS,
      payload: {
        responseData: {
          email: requestBody.payload.email,
          message: response.message,
          token: response.token,
          id: jwtDecode(response.token).userId,
          companyId: jwtDecode(response.token).companyId,
          username: jwtDecode(response.token).username,
          profileURL: jwtDecode(response.token).profileURL,
          companyName: jwtDecode(response.token).companyName,
          permissions: jwtDecode(response.token)?.permissions,
          role: jwtDecode(response.token)?.role,
          name: jwtDecode(response.token)?.name,
          signature: jwtDecode(response.token)?.signature
        },
      },
    });
  } catch (error) {
    yield put({ type: LOGIN_USER_FAILED, payload: { error: error } });
  }
}

function* signupUser(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "authentication/signup",
      requestBody.payload
    );
    console.log(response);
    yield put({
      type: SIGNUP_USER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SIGNUP_USER_FAILED, payload: { error: error } });
  }
}

function* getTeams(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(postApiWorker, "teams", requestBody.payload);
    yield put({ type: GET_TEAMS_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_TEAMS_FAILED, payload: { error: error } });
  }
}

function* getItems(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(postApiWorker, "items", requestBody.payload);
    yield put({ type: GET_ITEMS_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_ITEMS_FAILED, payload: { error: error } });
  }
}

function* getPaginatedItems(requestBody) {
  try {
    const response = yield call(postApiWorker, "items/getPaginatedItems", requestBody.payload);
    yield put({
      type: GET_ITEMS_PAGINATED_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ITEMS_PAGINATED_FAILED, payload: { error: error } });
  }
}

function* addItem(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "items/addItem",
      requestBody.payload,
      true
    );
    yield put({ type: ADD_ITEM_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: ADD_ITEM_FAILED, payload: { error: error } });
  }
}

function* addBuyerSupplier(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "buyerSupplier/addbuyerSupplier",
      requestBody.payload
    );
    yield put({
      type: ADD_BUYER_SUPPLIER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_BUYER_SUPPLIER_FAILED, payload: { error: error } });
  }
}

function* editBuyerSupplier(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "buyerSupplier/editBuyerSupplier",
      requestBody.payload
    );
    yield put({
      type: EDIT_BUYER_SUPPLIER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_BUYER_SUPPLIER_FAILED, payload: { error: error } });
  }
}

function* getBuyerSupplier(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "buyerSupplier",
      requestBody.payload
    );
    yield put({
      type: GET_BUYER_SUPPLIER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BUYER_SUPPLIER_FAILED, payload: { error: error } });
  }
}

function* deleteBuyerSupplier(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "buyerSupplier/deleteBuyerSupplier",
      requestBody.payload
    );
    yield put({
      type: DELETE_BUYER_SUPPLIER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: DELETE_BUYER_SUPPLIER_FAILED,
      payload: { error: error },
    });
  }
}

function* bulkDeleteBuyerSupplier(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "buyerSupplier/bulkDeleteBuyerSupplier",
      requestBody.payload
    );
    yield put({
      type: BULK_DELETE_BUYER_SUPPLIER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: BULK_DELETE_BUYER_SUPPLIER_FAILED,
      payload: { error: error },
    });
  }
}

function* getCompanyDetailsByGstn(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "buyerSupplier/getCompanyDetailsByGstNumber",
      requestBody.payload
    );
    console.log(response)
    yield put({
      type: GET_COMPANY_DETAILS_BY_GSTN_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_COMPANY_DETAILS_BY_GSTN_FAILED, payload: {
        error: error
      }
    });
  }
}

function* editItem(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "items/editItem",
      requestBody.payload,
      true
    );
    yield put({ type: EDIT_ITEM_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: EDIT_ITEM_FAILED, payload: { error: error } });
  }
}

function* deleteItem(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "items/deleteItem",
      requestBody.payload
    );
    yield put({
      type: DELETE_ITEM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_ITEM_FAILED, payload: { error: error } });
  }
}

function* bulkDeleteItem(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "items/deleteItems",
      requestBody.payload
    );
    yield put({
      type: BULK_DELETE_ITEM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BULK_DELETE_ITEM_FAILED, payload: { error: error } });
  }
}

function* bulkUploadItem(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "items/addBulkItem",
      requestBody.payload,
      true
    );
    yield put({
      type: BULK_UPLOAD_ITEM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BULK_UPLOAD_ITEM_FAILED, payload: { error: error } });
  }
}

function* bulkEditItem(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "items/editBulkItem",
      requestBody.payload,
      true
    );
    yield put({
      type: BULK_EDIT_ITEM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BULK_EDIT_ITEM_FAILED, payload: { error: error } });
  }
}

function* bulkReconcilationItem(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "items/stockReconcilation",
      requestBody.payload,
      true
    );
    yield put({
      type: BULK_RECONCILATION_ITEM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BULK_RECONCILATION_ITEM_FAILED, payload: { error: error } });
  }
}

function* bulkUploadAlternateUnit(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "items/addbulkAlternateUnits",
      requestBody.payload,
      true
    );
    yield put({
      type: BULK_UPLOAD_ALTERNATE_UNIT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BULK_UPLOAD_ALTERNATE_UNIT_FAILED, payload: { error: error } });
  }
}

function* bulkStockUpdate(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "items/bulkStockUpdate",
      requestBody.payload,
      true
    );
    yield put({
      type: BULK_STOCK_UPDATE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BULK_STOCK_UPDATE_FAILED, payload: { error: error } });
  }
}

function* getLastUpdatedPrice(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "items/getLastUpdatedPrice",
      requestBody.payload
    );
    yield put({
      type: GET_LAST_UPDATED_PRICE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_LAST_UPDATED_PRICE_FAILED, payload: { error: error } });
  }
}

function* addTeam(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "teams/addTeam",
      requestBody.payload
    );
    yield put({ type: ADD_TEAM_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: ADD_TEAM_FAILED, payload: { error: error } });
  }
}

function* editTeam(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "teams/editTeam",
      requestBody.payload
    );
    yield put({ type: EDIT_TEAM_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: EDIT_TEAM_FAILED, payload: { error: error } });
  }
}

function* deleteTeam(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "teams/deleteTeam",
      requestBody.payload
    );
    yield put({
      type: DELETE_TEAM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_TEAM_FAILED, payload: { error: error } });
  }
}

function* getUsers(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(postApiWorker, "users", requestBody.payload);
    yield put({ type: GET_USERS_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_USERS_FAILED, payload: { error: error } });
  }
}

function* getPartialUser(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(postApiWorker, "users/partialUser", requestBody.payload);
    yield put({ type: GET_PARTIAL_USER_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_PARTIAL_USER_FAILED, payload: { error: error } });
  }
}

function* getCompanies(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(postApiWorker, "users/getCompanies", requestBody.payload);
    yield put({ type: GET_COMPANIES_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_COMPANIES_FAILED, payload: { error: error } });
  }
}

function* deleteCompaniesData(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(postApiWorker, "deleteCompaniesData", requestBody.payload);
    yield put({ type: DELETE_COMPANIES_DATA_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: DELETE_COMPANIES_DATA_FAILED, payload: { error: error } });
  }
}

function* addUser(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "users/addUser",
      requestBody.payload
    );
    yield put({ type: ADD_USER_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: ADD_USER_FAILED, payload: { error: error } });
  }
}

function* editUser(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "users/editUser",
      requestBody.payload
    );
    yield put({ type: EDIT_USER_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: EDIT_USER_FAILED, payload: { error: error } });
  }
}

function* deleteUser(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "users/deleteUser",
      requestBody.payload
    );
    yield put({
      type: DELETE_USER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_USER_FAILED, payload: { error: error } });
  }
}

function* updateUser(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "users/updateProfile",
      requestBody.payload
    );

    yield put({
      type: UPDATE_USER_SUCCESS,
      payload: { responseData: response },
    });
    yield put({
      type: LOGIN_USER_SUCCESS,
      payload: {
        responseData: {
          email: response.email,
          message: response.message,
          token: response.token,
          id: jwtDecode(response.token).userId,
          companyId: jwtDecode(response.token).companyId,
          username: jwtDecode(response.token).username,
          profileURL: jwtDecode(response.token).profileURL,
          companyName: jwtDecode(response.token).companyName,
          permissions: jwtDecode(response.token)?.permissions,
          role: jwtDecode(response.token)?.role,
          name: jwtDecode(response.token)?.name,
          signature: jwtDecode(response.token)?.signature
        },
      },
    });
  } catch (error) {
    yield put({ type: UPDATE_USER_FAILED, payload: { error: error } });
  }
}

function* updateProfileLogo(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "users/updateProfileURL",
      requestBody.payload
    );
    yield put({
      type: UPDATE_PROFILE_LOGO_SUCCESS,
      payload: { responseData: response },
    });
    yield put({
      type: LOGIN_USER_SUCCESS,
      payload: {
        responseData: {
          email: response.email,
          message: response.message,
          token: response.token,
          id: jwtDecode(response.token).userId,
          companyId: jwtDecode(response.token).companyId,
          username: jwtDecode(response.token).username,
          profileURL: jwtDecode(response.token).profileURL,
          companyName: jwtDecode(response.token).companyName,
          permissions: jwtDecode(response.token)?.permissions,
          role: jwtDecode(response.token)?.role,
          name: jwtDecode(response.token)?.name,
          signature: jwtDecode(response.token)?.signature
        },
      },
    });
  } catch (error) {
    yield put({ type: UPDATE_PROFILE_LOGO_FAILED, payload: { error: error } });
  }
}

function* updateSignature(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "users/updateSignature",
      requestBody.payload
    );
    yield put({
      type: UPDATE_SIGNATURE_SUCCESS,
      payload: { responseData: response },
    });
    yield put({
      type: LOGIN_USER_SUCCESS,
      payload: {
        responseData: {
          email: response.email,
          message: response.message,
          token: response.token,
          id: jwtDecode(response.token).userId,
          companyId: jwtDecode(response.token).companyId,
          username: jwtDecode(response.token).username,
          profileURL: jwtDecode(response.token).profileURL,
          companyName: jwtDecode(response.token).companyName,
          permissions: jwtDecode(response.token)?.permissions,
          role: jwtDecode(response.token)?.role,
          name: jwtDecode(response.token)?.name,
          signature: jwtDecode(response.token)?.signature
        },
      },
    });
  } catch (error) {
    yield put({ type: UPDATE_SIGNATURE_FAILED, payload: { error: error } });
  }
}

function* addBlog(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "blogs/addBlog",
      requestBody.payload
    );
    yield put({ type: ADD_BLOG_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: ADD_BLOG_FAILED, payload: { error: error } });
  }
}

function* editBlog(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "blogs/editBlog",
      requestBody.payload
    );
    yield put({ type: EDIT_BLOG_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: EDIT_BLOG_FAILED, payload: { error: error } });
  }
}

function* deleteBlog(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "blogs/deleteBlog",
      requestBody.payload
    );
    yield put({
      type: DELETE_BLOG_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BLOG_FAILED, payload: { error: error } });
  }
}

function* getBlogById(requestBody) {
  console.log(requestBody.payload);
  try {
    const { id, title } = requestBody.payload;
    const response = yield call(
      getApiWorker,
      `blogs/${id}/${title}`,
      requestBody.payload.id
    );
    yield put({
      type: GET_BLOG_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BLOG_BY_ID_FAILED, payload: { error: error } });
  }
}

function* getBlogs(requestBody) {
  try {
    const response = yield call(getApiWorker, "blogs", requestBody.payload);
    yield put({ type: GET_BLOGS_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_BLOGS_FAILED, payload: { error: error } });
  }
}

function* getBlogsCategories(requestBody) {
  try {
    const response = yield call(getApiWorker, "blogs/categories", requestBody.payload);
    yield put({ type: GET_BLOGS_CATEGORIES_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_BLOGS_CATEGORIES_FAILED, payload: { error: error } });
  }
}

function* blogsSearch(requestBody) {
  try {
    const response = yield call(postApiWorker, "blogs/searchBlogs", requestBody.payload);
    yield put({ type: BLOGS_SEARCH_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: BLOGS_SEARCH_FAILED, payload: { error: error } });
  }
}


function* uploadImage(action) {
  try {
    const response = yield call(
      postApiWorker,
      "uploads/uploads",
      action.payload,
      true
    );

    yield put({ type: UPLOAD_IMAGE_SUCCESS, payload: { url: response.url } });
  } catch (error) {
    yield put({ type: UPLOAD_IMAGE_FAILED, payload: { error: error.message } });
  }
}

function* addStore(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "stores/addStore",
      requestBody.payload
    );
    yield put({ type: ADD_STORE_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: ADD_STORE_FAILED, payload: { error: error } });
  }
}

function* getStores(requestBody) {
  try {
    const response = yield call(postApiWorker, "stores", requestBody.payload);
    yield put({ type: GET_STORE_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_STORE_FAILED, payload: { error: error } });
  }
}

function* getStoreById(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/id",
      requestBody.payload
    );
    yield put({
      type: GET_STORE_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_STORE_BY_ID_FAILED, payload: { error: error } });
  }
}

function* getStoreByItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/getStoresByItem",
      requestBody.payload
    );
    yield put({
      type: GET_STORE_BY_ITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_STORE_BY_ITEMS_FAILED, payload: { error: error } });
  }
}

function* getAllStoreItemsByStoresID(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/getAllStoreItemsByStoresID",
      requestBody.payload
    );
    yield put({
      type: GET_ALL_STORE_ITEMS_BY_STORES_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ALL_STORE_ITEMS_BY_STORES_ID_FAILED, payload: { error: error } });
  }
}

function* getAllStoresWithItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/getAllStoresWithItems",
      requestBody.payload
    );
    yield put({
      type: GET_ALL_STORES_WITH_ITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ALL_STORES_WITH_ITEMS_FAILED, payload: { error: error } });
  }
}

function* editStore(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/editStore",
      requestBody.payload
    );
    yield put({
      type: EDIT_STORE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_STORE_FAILED, payload: { error: error } });
  }
}

function* getAllStockValues(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/getCompanyStoreTotals",
      requestBody.payload
    );
    yield put({
      type: GET_ALL_STOCKS_VALUES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ALL_STOCKS_VALUES_FAILED, payload: { error: error } });
  }
}

function* deleteStore(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/deleteStore",
      requestBody.payload
    );
    yield put({
      type: DELETE_STORE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_STORE_FAILED, payload: { error: error } });
  }
}

function* getStoreByItem(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/getStoreItemsByStoreId",
      requestBody.payload
    );
    yield put({ type: GET_STORE_BY_ITEM_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_STORE_BY_ITEM_FAILED, payload: { error: error } });
  }
}

function* setDefaultStore(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/setDefaultStore",
      requestBody.payload
    );
    yield put({ type: SET_DEFAULT_STORE_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: SET_DEFAULT_STORE_FAILED, payload: { error: error } });
  }
}

function* addAddress(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "address/addAddress",
      requestBody.payload
    );
    yield put({
      type: ADD_ADDRESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_ADDRESS_FAILED, payload: { error: error } });
  }
}

function* getAddress(requestBody) {
  try {
    const response = yield call(postApiWorker, "address", requestBody.payload);
    yield put({
      type: GET_ADDRESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ADDRESS_FAILED, payload: { error: error } });
  }
}

function* editAddress(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "address/editAddress",
      requestBody.payload
    );
    yield put({
      type: EDIT_ADDRESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_ADDRESS_FAILED, payload: { error: error } });
  }
}

function* deleteAddress(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "address/deleteAddress",
      requestBody.payload
    );
    yield put({
      type: DELETE_ADDRESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_ADDRESS_FAILED, payload: { error: error } });
  }
}

function* setDefaultAddress(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "address/setDefaultAddress",
      requestBody.payload
    );
    yield put({
      type: SET_DEFAULT_ADDRESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SET_DEFAULT_ADDRESS_FAILED, payload: { error: error } });
  }
}

function* addBlogComment(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "blogComments/addBlogComments",
      requestBody.payload
    );
    yield put({
      type: ADD_COMMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_COMMENT_FAILED, payload: { error: error } });
  }
}

function* deleteBlogComment(requestBody) {
  try {
    console.log(requestBody);
    const response = yield call(
      postApiWorker,
      "blogComments/deleteBlogComment",
      requestBody.payload
    );
    yield put({
      type: DELETE_COMMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_COMMENT_FAILED, payload: { error: error } });
  }
}

function* approveComments(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "blogComments/approveBlogComments",
      requestBody.payload
    );
    yield put({
      type: APPROVE_COMMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: APPROVE_COMMENT_FAILED, payload: { error: error } });
  }
}

function* getApprovedBlogComments(requestBody) {
  console.log(requestBody);
  try {
    const response = yield call(
      postApiWorker,
      "blogComments",
      requestBody.payload
    );
    yield put({
      type: GET_APPROVE_BLOG_COMMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_APPROVE_BLOG_COMMENT_FAILED,
      payload: { error: error },
    });
  }
}

function* getBlogCommentstoBeApprove(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "blogComments/getCommentstoApprove",
      requestBody.payload
    );
    yield put({
      type: GET_BLOG_COMMENTS_TO_BE_APPROVED_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_BLOG_COMMENTS_TO_BE_APPROVED_FAILED,
      payload: { error: error },
    });
  }
}

function* getAllBlogsApprovedComments(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "blogComments/getApprovedComments",
      requestBody.payload
    );
    yield put({
      type: GET_ALL_BLOGS_APPROVED_COMMENTS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_ALL_BLOGS_APPROVED_COMMENTS_FAILED,
      payload: { error: error },
    });
  }
}

function* addDocumentSeries(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "documentSeries/AddDocumentSeries",
      requestBody.payload
    );
    yield put({
      type: ADD_DOCUMENT_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_DOCUMENT_SERIES_FAILED, payload: { error: error } });
  }
}

function* getDocumentSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documentSeries",
      requestBody.payload
    );
    yield put({
      type: GET_DOCUMENT_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_DOCUMENT_SERIES_FAILED, payload: { error: error } });
  }
}

function* editDocumentSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documentSeries/editDocumentSeries",
      requestBody.payload
    );
    yield put({
      type: EDIT_DOCUMENT_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_DOCUMENT_SERIES_FAILED, payload: { error: error } });
  }
}

function* deleteDocumentSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documentSeries/deleteDocumentSeries",
      requestBody.payload
    );
    yield put({
      type: DELETE_DOCUMENT_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: DELETE_DOCUMENT_SERIES_FAILED,
      payload: { error: error },
    });
  }
}

function* updateLastDocumentNumber(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documentSeries/updateLastDocumentNumber",
      requestBody.payload
    );
    yield put({
      type: UPDATE_LAST_DOCUMENT_NUMBER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: UPDATE_LAST_DOCUMENT_NUMBER_FAILED,
      payload: { error: error },
    });
  }
}

function* setDefaultSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documentSeries/setAsDefault",
      requestBody.payload
    );
    yield put({
      type: SET_DEFAULT_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SET_DEFAULT_SERIES_FAILED, payload: { error: error } });
  }
}

function* addBOMSeries(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomSeries/addBOMSeries",
      requestBody.payload
    );
    yield put({
      type: ADD_BOM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_BOM_SERIES_FAILED, payload: { error: error } });
  }
}

function* getBOMSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomSeries",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BOM_SERIES_FAILED, payload: { error: error } });
  }
}

function* editBOMSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomSeries/editBOMSeries",
      requestBody.payload
    );
    yield put({
      type: EDIT_BOM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_BOM_SERIES_FAILED, payload: { error: error } });
  }
}

function* deleteBOMSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomSeries/deleteBOMSeries",
      requestBody.payload
    );
    yield put({
      type: DELETE_BOM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: DELETE_BOM_SERIES_FAILED,
      payload: { error: error },
    });
  }
}

function* updateLastBOMNumber(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomSeries/updateLastBOMNumber",
      requestBody.payload
    );
    yield put({
      type: UPDATE_LAST_BOM_NUMBER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: UPDATE_LAST_BOM_NUMBER_FAILED,
      payload: { error: error },
    });
  }
}

function* setDefaultBOMSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomSeries/setDefaultBOMSeries",
      requestBody.payload
    );
    yield put({
      type: SET_DEFAULT_BOM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SET_DEFAULT_BOM_SERIES_FAILED, payload: { error: error } });
  }
}

function* addItemSeries(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "itemSeries/addItemSeries",
      requestBody.payload
    );
    yield put({
      type: ADD_ITEM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_ITEM_SERIES_FAILED, payload: { error: error } });
  }
}

function* getItemSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "itemSeries",
      requestBody.payload
    );
    yield put({
      type: GET_ITEM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ITEM_SERIES_FAILED, payload: { error: error } });
  }
}

function* editItemSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "itemSeries/editItemSeries",
      requestBody.payload
    );
    yield put({
      type: EDIT_ITEM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_ITEM_SERIES_FAILED, payload: { error: error } });
  }
}

function* deleteItemSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "itemSeries/deleteItemSeries",
      requestBody.payload
    );
    yield put({
      type: DELETE_ITEM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: DELETE_ITEM_SERIES_FAILED,
      payload: { error: error },
    });
  }
}

function* updateLastItemNumber(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "itemSeries/updateLastItemNumber",
      requestBody.payload
    );
    yield put({
      type: UPDATE_LAST_ITEM_NUMBER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: UPDATE_LAST_ITEM_NUMBER_FAILED,
      payload: { error: error },
    });
  }
}

function* setDefaultItemSeries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "itemSeries/setDefaultItemSeries",
      requestBody.payload
    );
    yield put({
      type: SET_DEFAULT_ITEM_SERIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SET_DEFAULT_ITEM_SERIES_FAILED, payload: { error: error } });
  }
}

function* addBankDetail(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "accountDetails/addAccountDetails",
      requestBody.payload
    );
    yield put({
      type: ADD_BANK_DETAIL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_BANK_DETAIL_FAILED, payload: { error: error } });
  }
}

function* getBankDetail(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "accountDetails",
      requestBody.payload
    );
    yield put({
      type: GET_BANK_DETAIL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BANK_DETAIL_FAILED, payload: { error: error } });
  }
}

function* editBankDetail(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "accountDetails/editAccountDetails",
      requestBody.payload
    );
    yield put({
      type: EDIT_BANK_DETAIL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_BANK_DETAIL_FAILED, payload: { error: error } });
  }
}

function* deleteBankDetail(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "accountDetails/deleteAccountDetails",
      requestBody.payload
    );
    yield put({
      type: DELETE_BANK_DETAIL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BANK_DETAIL_FAILED, payload: { error: error } });
  }
}

function* getDocuments(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents",
      requestBody.payload
    );
    yield put({
      type: GET_DOCUMENTS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_DOCUMENTS_FAILED, payload: { error: error } });
  }
}

function* getTableDocuments(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents",
      requestBody.payload
    );
    yield put({
      type: GET_TABLE_DOCUMENTS_SUCCESS,
      payload: { responseData: response, requestPayload: requestBody.payload },
    });
  } catch (error) {
    yield put({
      type: GET_TABLE_DOCUMENTS_FAILED,
      payload: { error: error, requestPayload: requestBody.payload },
    });
  }
}

function* getDocumentById(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/getDocumentById",
      requestBody.payload
    );
    yield put({
      type: GET_DOCUMENTS_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_DOCUMENTS_BY_ID_FAILED, payload: { error: error } });
  }
}

function* fetchCurrentDoc(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/fetchCurrentDoc",
      requestBody.payload
    );
    yield put({
      type: FETCH_CURRENT_DOC_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: FETCH_CURRENT_DOC_FAILED, payload: { error: error } });
  }
}

function* createDocument(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/createDocument",
      requestBody.payload
    );
    yield put({
      type: CREATE_DOCUMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_DOCUMENT_FAILED, payload: { error: error } });
  }
}

function* getApprovalHistory(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/getApprovalHistory", // your backend route
      requestBody.payload
    );
    yield put({
      type: GET_APPROVAL_HISTORY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_APPROVAL_HISTORY_FAILED,
      payload: { error },
    });
  }
}


function* changeApprovalStatus(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/approvalStatus", // your backend route
      requestBody.payload
    );
    yield put({
      type: CHANGE_APPROVAL_STATUS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: CHANGE_APPROVAL_STATUS_FAILED,
      payload: { error },
    });
  }
}



function* getDocumentsByStatus(action) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/documentStatus", // backend route
      action.payload
    );
    yield put({
      type: GET_DOCUMENTS_BY_STATUS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_DOCUMENTS_BY_STATUS_FAILED, payload: { error } });
  }
}



function* editDocument(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/editDocument",
      requestBody.payload
    );
    yield put({
      type: EDIT_DOCUMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_DOCUMENT_FAILED, payload: { error: error } });
  }
}

function* saveRfqQuotation(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/saveRfqQuotation",
      requestBody.payload
    );
    yield put({
      type: SAVE_RFQ_QUOTATION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SAVE_RFQ_QUOTATION_FAILED, payload: { error: error } });
  }
}

function* discardDocument(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/discardDocument",
      requestBody.payload
    );
    yield put({
      type: DISCARD_DOCUMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DISCARD_DOCUMENT_FAILED, payload: { error: error } });
  }
}

function* deleteDocument(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/deleteDocument",
      requestBody.payload
    );
    yield put({
      type: DELETE_DOCUMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_DOCUMENT_FAILED, payload: { error: error } });
  }
}

function* shortCloseTransaction(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/shortCloseTranscation",
      requestBody.payload
    );
    yield put({
      type: SHORT_CLOSE_TRANSACTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SHORT_CLOSE_TRANSACTION_FAILED, payload: { error: error } });
  }
}

function* getSalesDocumentItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/getSalesDocumentItems",
      requestBody.payload
    );
    yield put({
      type: GET_SALES_DOCUMENTS_ITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_SALES_DOCUMENTS_ITEMS_FAILED, payload: { error: error } });
  }
}

function* getServiceChallanItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/getServiceChallanItems",
      requestBody.payload
    );
    yield put({
      type: GET_SERVICE_CHALLAN_ITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_SERVICE_CHALLAN_ITEMS_FAILED, payload: { error: error } });
  }
}

function* getDocumentItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/getDocumentItems",
      requestBody.payload
    );
    yield put({
      type: GET_DOCUMENT_ITEMS_SUCCESS,
      payload: { responseData: response?.receivedByItem },
    });
  } catch (error) {
    yield put({ type: GET_DOCUMENT_ITEMS_FAILED, payload: { error: error } });
  }
}

function* getChallanItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/getChallanDocumentItems",
      requestBody.payload
    );
    yield put({
      type: GET_CHALLAN_ITEMS_SUCCESS,
      payload: { responseData: response?.receivedByItem },
    });
  } catch (error) {
    yield put({ type: GET_CHALLAN_ITEMS_FAILED, payload: { error: error } });
  }
}

function* previewDocument(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/getPreviewDocuments",
      requestBody.payload
    );
    yield put({
      type: PREVIEW_DOCUMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: PREVIEW_DOCUMENT_FAILED, payload: { error: error } });
  }
}

function* createEInvoice(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/createEInvoice",
      requestBody.payload
    );
    yield put({
      type: CREATE_EINVOICE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_EINVOICE_FAILED, payload: { error: error } });
  }
}

function* createEWayBill(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/createEWayBill",
      requestBody.payload
    );
    yield put({
      type: CREATE_EWAYBILL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_EWAYBILL_FAILED, payload: { error: error } });
  }
}

function* createEWayBillFromEInvoice(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/createEwayBillFromEInvoice",
      requestBody.payload
    );
    yield put({
      type: CREATE_EWAYBILL_FROM_EINVOICE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_EWAYBILL_FROM_EINVOICE_FAILED, payload: { error: error } });
  }
}

function* cancelEInvoice(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/cancelEInvoice",
      requestBody.payload
    );
    yield put({
      type: CANCEL_EINVOICE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CANCEL_EINVOICE_FAILED, payload: { error: error } });
  }
}

function* cancelEWayBill(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/cancelEWayBill",
      requestBody.payload
    );
    yield put({
      type: CANCEL_EWAYBILL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CANCEL_EWAYBILL_FAILED, payload: { error: error } });
  }
}


function* emailDocument(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/emailDocument",
      requestBody.payload,
      true
    );
    yield put({
      type: EMAIL_DOCUMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EMAIL_DOCUMENT_FAILED, payload: { error: error } });
  }
}

function* notify(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "notification/notify",
      requestBody.payload
    );
    yield put({
      type: NOTIFY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: NOTIFY_FAILED, payload: { error: error } });
  }
}

function* getNotifications(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "notification",
      requestBody.payload
    );
    yield put({
      type: GET_NOTIFICATIONS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_NOTIFICATIONS_FAILED, payload: { error: error } });
  }
}

function* getAccountInfo(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "getAccountInfo",
      requestBody.payload
    );
    yield put({
      type: GET_ACCOUNT_INFO_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ACCOUNT_INFO_FAILED, payload: { error: error } });
  }
}

function* updateAccountInfo(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "updateAccountInfo",
      requestBody.payload
    );
    yield put({
      type: UPDATE_ACCOUNT_INFO_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_ACCOUNT_INFO_FAILED, payload: { error: error } });
  }
}

function* stockTransfer(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/stockTransfer",
      requestBody.payload
    );
    yield put({
      type: STOCK_TRANSFER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: STOCK_TRANSFER_FAILED, payload: { error: error } });
  }
}

function* stockUpdate(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/stockTransfer",
      requestBody.payload
    );
    yield put({
      type: STOCK_UPDATE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: STOCK_UPDATE_FAILED, payload: { error: error } });
  }
}

function* getUom(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(postApiWorker, "uom", requestBody.payload);
    yield put({ type: GET_UOM_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: GET_UOM_FAILED, payload: { error: error } });
  }
}

function* addUom(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "uom/addUOM",
      requestBody.payload
    );
    yield put({ type: ADD_UOM_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: ADD_UOM_FAILED, payload: { error: error } });
  }
}

function* editUom(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "uom/editUOM",
      requestBody.payload
    );
    yield put({ type: EDIT_UOM_SUCCESS, payload: { responseData: response } });
  } catch (error) {
    yield put({ type: EDIT_UOM_FAILED, payload: { error: error } });
  }
}

function* deleteUom(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "uom/deleteUOM",
      requestBody.payload
    );
    yield put({
      type: DELETE_UOM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_UOM_FAILED, payload: { error: error } });
  }
}

function* getPackagingMaster(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "packagingMaster",
      requestBody.payload
    );
    yield put({
      type: GET_PACKAGING_MASTER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_PACKAGING_MASTER_FAILED, payload: { error: error } });
  }
}

function* addPackagingMaster(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "packagingMaster/addPackagingMaster",
      requestBody.payload
    );
    yield put({
      type: ADD_PACKAGING_MASTER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_PACKAGING_MASTER_FAILED, payload: { error: error } });
  }
}

function* editPackagingMaster(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "packagingMaster/editPackagingMaster",
      requestBody.payload
    );
    yield put({
      type: EDIT_PACKAGING_MASTER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_PACKAGING_MASTER_FAILED, payload: { error: error } });
  }
}

function* deletePackagingMaster(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "packagingMaster/deletePackagingMaster",
      requestBody.payload
    );
    yield put({
      type: DELETE_PACKAGING_MASTER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_PACKAGING_MASTER_FAILED, payload: { error: error } });
  }
}

function* getItemMapping(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "itemMapping/getAll",
      requestBody.payload
    );
    yield put({
      type: GET_ITEM_MAPPING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ITEM_MAPPING_FAILED, payload: { error: error } });
  }
}

function* addItemMapping(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "itemMapping/create",
      requestBody.payload
    );
    yield put({
      type: ADD_ITEM_MAPPING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_ITEM_MAPPING_FAILED, payload: { error: error } });
  }
}

function* editItemMapping(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "itemMapping/update",
      requestBody.payload
    );
    yield put({
      type: EDIT_ITEM_MAPPING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_ITEM_MAPPING_FAILED, payload: { error: error } });
  }
}

function* deleteItemMapping(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "itemMapping/delete",
      requestBody.payload
    );
    yield put({
      type: DELETE_ITEM_MAPPING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_ITEM_MAPPING_FAILED, payload: { error: error } });
  }
}

function* getCategory(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "categories",
      requestBody.payload
    );
    yield put({
      type: GET_CATEGORY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_CATEGORY_FAILED, payload: { error: error } });
  }
}

function* addCategory(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "categories/addCategory",
      requestBody.payload
    );
    yield put({
      type: ADD_CATEGORY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_CATEGORY_FAILED, payload: { error: error } });
  }
}

function* editCategory(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "categories/editCategory",
      requestBody.payload
    );
    yield put({
      type: EDIT_CATEGORY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_CATEGORY_FAILED, payload: { error: error } });
  }
}

function* deleteCategory(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "categories/deleteCategory",
      requestBody.payload
    );
    yield put({
      type: DELETE_CATEGORY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_CATEGORY_FAILED, payload: { error: error } });
  }
}

function* itemStockTransferHistory(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/getItemStockTransferHistory",
      requestBody.payload
    );
    yield put({
      type: ITEM_STOCK_TRANSFER_HISTORY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: ITEM_STOCK_TRANSFER_HISTORY_FAILED,
      payload: { error: error },
    });
  }
}

function* stockTransferHistory(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/getStockTransferHistory",
      requestBody.payload
    );
    yield put({
      type: STOCK_TRANSFER_HISTORY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: STOCK_TRANSFER_HISTORY_FAILED,
      payload: { error: error },
    });
  }
}

function* stockReconcile(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/stockReconcile",
      requestBody.payload
    );
    yield put({
      type: STOCK_RECONCILE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: STOCK_RECONCILE_FAILED,
      payload: { error: error },
    });
  }
}

function* getPaymentTerm(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "paymentTerms",
      requestBody.payload
    );
    yield put({
      type: GET_PAYMENT_TERMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_PAYMENT_TERMS_FAILED,
      payload: { error: error },
    });
  }
}

function* addPaymentTerm(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "paymentTerms/addPaymentTerms",
      requestBody.payload
    );
    yield put({
      type: ADD_PAYMENT_TERMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_PAYMENT_TERMS_FAILED, payload: { error: error } });
  }
}

function* editPaymentTerm(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "paymentTerms/editPaymentTerms",
      requestBody.payload
    );
    yield put({
      type: EDIT_PAYMENT_TERMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_PAYMENT_TERMS_FAILED, payload: { error: error } });
  }
}

function* deletePaymentTerm(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "paymentTerms/deletePaymentTerms",
      requestBody.payload
    );
    yield put({
      type: DELETE_PAYMENT_TERMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_PAYMENT_TERMS_FAILED, payload: { error: error } });
  }
}

function* getLogisticDetails(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "logisticDetails",
      requestBody.payload
    );
    yield put({
      type: GET_LOGISTIC_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_LOGISTIC_DETAILS_FAILED,
      payload: { error: error },
    });
  }
}

function* addLogisticDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "logisticDetails/addLogisticDetails",
      requestBody.payload
    );
    yield put({
      type: ADD_LOGISTIC_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_LOGISTIC_DETAILS_FAILED, payload: { error: error } });
  }
}

function* editLogisticDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "logisticDetails/editLogisticDetails",
      requestBody.payload
    );
    yield put({
      type: EDIT_LOGISTIC_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: EDIT_LOGISTIC_DETAILS_FAILED,
      payload: { error: error },
    });
  }
}

function* deleteLogisticDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "logisticDetails/deleteLogisticDetails",
      requestBody.payload
    );
    yield put({
      type: DELETE_LOGISTIC_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: DELETE_LOGISTIC_DETAILS_FAILED,
      payload: { error: error },
    });
  }
}

function* getTransporterDetails(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "transporterDetails/getTransporterDetails",
      requestBody.payload
    );
    yield put({
      type: GET_TRANSPORTER_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_TRANSPORTER_DETAILS_FAILED,
      payload: { error: error },
    });
  }
}

function* addTransporterDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "transporterDetails/addTransporterDetails",
      requestBody.payload
    );
    yield put({
      type: ADD_TRANSPORTER_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: ADD_TRANSPORTER_DETAILS_FAILED,
      payload: { error: error },
    });
  }
}

function* editTransporterDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "transporterDetails/ediTtransporterDetails",
      requestBody.payload
    );
    yield put({
      type: EDIT_TRANSPORTER_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: EDIT_TRANSPORTER_DETAILS_FAILED,
      payload: { error: error },
    });
  }
}

function* deleteTransporterDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "transporterDetails/deleteTransporterDetails",
      requestBody.payload
    );
    yield put({
      type: DELETE_TRANSPORTER_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: DELETE_TRANSPORTER_DETAILS_FAILED,
      payload: { error: error },
    });
  }
}

function* reportColumnslPrefrence(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "reportColumns/columnslPrefrence",
      requestBody.payload
    );
    yield put({
      type: REPORT_COLUMNS_PREFRENCE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: REPORT_COLUMNS_PREFRENCE_FAILED,
      payload: { error: error },
    });
  }
}

function* getTermsCondition(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "termsCondition/getTermsCondition",
      requestBody.payload
    );
    yield put({
      type: GET_TERMS_CONDITION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_TERMS_CONDITION_FAILED,
      payload: { error: error },
    });
  }
}

function* addTermsCondition(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "termsCondition/addTermsCondition",
      requestBody.payload
    );
    yield put({
      type: ADD_TERMS_CONDITION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_TERMS_CONDITION_FAILED, payload: { error: error } });
  }
}

function* editTermsCondition(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "termsCondition/editTermsCondition",
      requestBody.payload
    );
    yield put({
      type: EDIT_TERMS_CONDITION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_TERMS_CONDITION_FAILED, payload: { error: error } });
  }
}

function* deleteTermsCondition(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "termsCondition/deleteTermsCondition",
      requestBody.payload
    );
    yield put({
      type: DELETE_TERMS_CONDITION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: DELETE_TERMS_CONDITION_FAILED,
      payload: { error: error },
    });
  }
}

function* getCustomFields(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "customFields/getCustomFields",
      requestBody.payload
    );
    yield put({
      type: GET_CUSTOM_FIELDS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_CUSTOM_FIELDS_FAILED,
      payload: { error: error },
    });
  }
}

function* addCustomFields(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "customFields/addCustomFields",
      requestBody.payload,
      true
    );
    yield put({
      type: ADD_CUSTOM_FIELDS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_CUSTOM_FIELDS_FAILED, payload: { error: error } });
  }
}

function* editCustomFields(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "customFields/editCustomFields",
      requestBody.payload,
    );
    yield put({
      type: EDIT_CUSTOM_FIELDS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_CUSTOM_FIELDS_FAILED, payload: { error: error } });
  }
}

function* editCustomField(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "customFields/editCustomField",
      requestBody.payload,
      true
    );
    yield put({
      type: EDIT_CUSTOM_FIELD_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_CUSTOM_FIELD_FAILED, payload: { error: error } });
  }
}

function* deleteCustomFields(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "customFields/deleteCustomFields",
      requestBody.payload
    );
    yield put({
      type: DELETE_CUSTOM_FIELDS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_CUSTOM_FIELDS_FAILED, payload: { error: error } });
  }
}

function* getCustomForms(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "customForms/getCustomForms",
      requestBody.payload
    );
    yield put({
      type: GET_CUSTOM_FORMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_CUSTOM_FORMS_FAILED,
      payload: { error: error },
    });
  }
}

function* addCustomForms(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "customForms/addCustomForm",
      requestBody.payload
    );
    yield put({
      type: ADD_CUSTOM_FORMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_CUSTOM_FORMS_FAILED, payload: { error: error } });
  }
}

function* editCustomForms(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "customForms/editCustomForm",
      requestBody.payload
    );
    yield put({
      type: EDIT_CUSTOM_FORMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_CUSTOM_FORMS_FAILED, payload: { error: error } });
  }
}

function* deleteCustomForms(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "customForms/deleteCustomForm",
      requestBody.payload
    );
    yield put({
      type: DELETE_CUSTOM_FORMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_CUSTOM_FORMS_FAILED, payload: { error: error } });
  }
}

function* editPermission(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "customFields/editPermissions",
      requestBody.payload
    );
    yield put({
      type: EDIT_PERMISSIONS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_PERMISSIONS_FAILED, payload: { error: error } });
  }
}

function* getContactUs(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "contactUs",
      requestBody.payload
    );
    yield put({
      type: GET_CONTACT_US_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_CONTACT_US_FAILED,
      payload: { error: error },
    });
  }
}

function* addContactUs(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "contactUs/addContactUs",
      requestBody.payload
    );
    yield put({
      type: ADD_CONTACT_US_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_CONTACT_US_FAILED, payload: { error: error } });
  }
}

function* getDemoQueryData(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "demoQuery",
      requestBody.payload
    );
    yield put({
      type: GET_REQUEST_DEMO_QUERY_DATA_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_REQUEST_DEMO_QUERY_DATA_FAILED,
      payload: { error: error },
    });
  }
}

function* addDemoQueryData(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "demoQuery/addDemoQuery",
      requestBody.payload
    );
    yield put({
      type: ADD_REQUEST_DEMO_QUERY_DATA_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: ADD_REQUEST_DEMO_QUERY_DATA_FAILED,
      payload: { error: error },
    });
  }
}

function* getNewsLetters(requestBody) {
  try {
    const response = yield call(
      getApiWorker,
      "newsLetter",
      requestBody.payload
    );
    yield put({
      type: GET_NEWS_LETTERS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_NEWS_LETTERS_FAILED,
      payload: { error: error },
    });
  }
}

function* addNewsLetters(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "newsLetter/addNewsLetters",
      requestBody.payload
    );
    yield put({
      type: ADD_NEWS_LETTERS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: ADD_NEWS_LETTERS_FAILED,
      payload: { error: error },
    });
  }
}

function* unSubscribeNewsLetter(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "newsLetter/unSubscribeNewsLetter",
      requestBody.payload
    );
    yield put({
      type: UNSUBSCRIBE_NEWS_LETTERS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: UNSUBSCRIBE_NEWS_LETTERS_FAILED,
      payload: { error: error },
    });
  }
}

function* forgotPassword(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "authentication/forgotPassword",
      requestBody.payload
    );

    yield put({
      type: FORGOT_PASSWORD_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: FORGOT_PASSWORD_FAILED, payload: { error: error } });
  }
}

function* resetPassword(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "authentication/resetPassword",
      requestBody.payload
    );

    yield put({
      type: RESET_PASSWORD_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: RESET_PASSWORD_FAILED, payload: { error: error } });
  }
}

function* getItemCount(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getTotalItems",
      requestBody.payload
    );
    yield put({
      type: GET_ITEMS_COUNT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ITEMS_COUNT_FAILURE, payload: { error: error } });
  }
}

function* getStoresCount(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getTotalStores",
      requestBody.payload
    );
    yield put({
      type: GET_STORES_COUNT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_STORES_COUNT_FAILURE, payload: { error: error } });
  }
}

function* getUsersCount(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getTotalUsersByCompany",
      requestBody.payload
    );
    yield put({
      type: GET_USERS_COUNT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_USERS_COUNT_FAILURE, payload: { error: error } });
  }
}

function* getDocumentsCount(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getTotalDocuments",
      requestBody.payload
    );
    yield put({
      type: GET_DOCUMENTS_COUNT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_DOCUMENTS_COUNT_FAILURE, payload: { error: error } });
  }
}

function* getCompaniesCount(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getBuyerSupplierCount",
      requestBody.payload
    );
    yield put({
      type: GET_COMPANIES_COUNT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_COMPANIES_COUNT_FAILURE, payload: { error: error } });
  }
}

function* getItemsSalesSummary(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getItemSalesSummary",
      requestBody.payload
    );
    yield put({
      type: GET_ITEMS_SALES_SUMMARY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ITEMS_SALES_SUMMARY_FAILURE, payload: { error: error } });
  }
}

function* getInvoiceSummary(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getDocumentsInvoiceSummary",
      requestBody.payload
    );
    yield put({
      type: GET_INVOICE_SUMMARY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_INVOICE_SUMMARY_FAILURE, payload: { error: error } });
  }
}

function* getDashboardData(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getDashboardData",
      requestBody.payload
    );
    yield put({
      type: GET_DASHBOARD_DATA_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_DASHBOARD_DATA_FAILURE, payload: { error: error } });
  }
}

function* getPredictionValue(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/predictNext30DaysTotalValue",
      requestBody.payload
    );
    yield put({
      type: PREDICT_NEXT_VALUE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: PREDICT_NEXT_VALUE_FAILURE, payload: { error: error } });
  }
}

function* getSalesPrediction(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/predictSales",
      requestBody.payload
    );
    yield put({
      type: PREDICT_SALES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: PREDICT_SALES_FAILURE, payload: { error: error } });
  }
}

function* getItemsSalesSummaryWithPrediction(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getItemSalesSummaryWithPrediction",
      requestBody.payload
    );
    yield put({
      type: GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_FAILURE, payload: { error: error } });
  }
}

function* getStoreWiseItems(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getStoreWiseItems",
      requestBody.payload
    );
    yield put({
      type: GET_STORE_WISE_ITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_STORE_WISE_ITEMS_FAILURE, payload: { error: error } });
  }
}

function* getCategoryWiseItems(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getCategoryWiseItems",
      requestBody.payload
    );
    yield put({
      type: GET_CATEGORY_WISE_ITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_CATEGORY_WISE_ITEMS_FAILURE, payload: { error: error } });
  }
}

function* getFastMovingSlowMovingItems(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/fastMovingSlowMovingItems",
      requestBody.payload
    );
    yield put({
      type: FAST_MOVING_SLOW_MOVING_ITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: FAST_MOVING_SLOW_MOVING_ITEMS_FAILURE, payload: { error: error } });
  }
}

function* getStockLevelAnalysis(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/stockLevelAnalysis",
      requestBody.payload
    );
    yield put({
      type: STOCK_LEVEL_ANALYSIS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: STOCK_LEVEL_ANALYSIS_FAILURE, payload: { error: error } });
  }
}

function* getStockAgeing(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/stockAgeing",
      requestBody.payload
    );
    yield put({
      type: STOCK_AGEING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: STOCK_AGEING_FAILURE, payload: { error: error } });
  }
}

function* getOnTimeDelayProduction(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/onTimeDelayProduction",
      requestBody.payload
    );
    yield put({
      type: ON_TIME_DELAY_PRODUCTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ON_TIME_DELAY_PRODUCTION_FAILURE, payload: { error: error } });
  }
}

function* getWorkOrderStatus(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/workOrderStatus",
      requestBody.payload
    );
    yield put({
      type: WORK_ORDER_STATUS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: WORK_ORDER_STATUS_FAILURE, payload: { error: error } });
  }
}

function* getSalesDashboardDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "dashboard/getSalesDashboardDetails",
      requestBody.payload
    );
    yield put({
      type: GET_SALES_DASHBOARD_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_SALES_DASHBOARD_DETAILS_FAILURE, payload: { error: error } });
  }
}

function* getInventoryService(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "inventoryServices",
      requestBody.payload
    );
    yield put({
      type: GET_INVENTORY_SERVICES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_INVENTORY_SERVICES_FAILED,
      payload: { error: error },
    });
  }
}

function* addInventoryService(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "inventoryServices/addInventoryServices",
      requestBody.payload
    );
    yield put({
      type: ADD_INVENTORY_SERVICES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_INVENTORY_SERVICES_FAILED, payload: { error: error } });
  }
}

function* editInventoryService(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "inventoryServices/editInventoryServices",
      requestBody.payload
    );
    yield put({
      type: EDIT_INVENTORY_SERVICES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_INVENTORY_SERVICES_FAILED, payload: { error: error } });
  }
}

function* deleteInventoryService(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "inventoryServices/deleteInventoryServices",
      requestBody.payload
    );
    yield put({
      type: DELETE_INVENTORY_SERVICES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_INVENTORY_SERVICES_FAILED, payload: { error: error } });
  }
}

function* getBatchItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "batchItems/getBatches",
      requestBody.payload
    );
    yield put({
      type: GET_BATCHITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BATCHITEMS_FAILED, payload: { error: error } });
  }
}


function* updateBatchItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "batchItems/updateBatchByItems",
      requestBody.payload
    );
    yield put({
      type: UPDATE_BATCHITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_BATCHITEMS_FAILED, payload: { error: error } });
  }
}


function* createBatchItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "batchItems/createBatches",
      requestBody.payload
    );
    yield put({
      type: CREATE_BATCHITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_BATCHITEMS_FAILED, payload: { error: error } });
  }
}

function* createSelectBatchItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "batchItems/createSelectBatch",
      requestBody.payload
    );
    yield put({
      type: CREATE_SELECT_BATCHITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_SELECT_BATCHITEMS_FAILED, payload: { error: error } });
  }
}

function* createProductionProcess(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "productionProcess/createProductionProcess",
      requestBody.payload
    );
    yield put({
      type: CREATE_PRODUCTION_PROCESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_PRODUCTION_PROCESS_FAILED, payload: { error: error } });
  }
}

function* getProductionProcess(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "productionProcess",
      requestBody.payload
    );
    yield put({
      type: GET_PRODUCTION_PROCESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_PRODUCTION_PROCESS_FAILED, payload: { error: error } });
  }
}

function* getProductionProcessById(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      getApiWorker,
      "productionProcess/getProductionProcessById",
      requestBody.payload
    );
    yield put({
      type: GET_PRODUCTION_PROCESS_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_PRODUCTION_PROCESS_BY_ID_FAILED, payload: { error: error } });
  }
}

function* updateProductionProcess(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "productionProcess/updateProductionProcess",
      requestBody.payload
    );
    yield put({
      type: UPDATE_PRODUCTION_PROCESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_PRODUCTION_PROCESS_FAILED, payload: { error: error } });
  }
}

function* deleteProductionProcess(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "productionProcess/deleteProductionProcess",
      requestBody.payload
    );
    yield put({
      type: DELETE_PRODUCTION_PROCESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_PRODUCTION_PROCESS_FAILED, payload: { error: error } });
  }
}

function* getAllProductions(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/getAllProductions",
      requestBody.payload
    );
    yield put({
      type: GET_ALL_PRODUCTIONS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ALL_PRODUCTIONS_FAILED, payload: { error: error } });
  }
}

function* deleteLogs(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/deleteLogs",
      requestBody.payload
    );
    yield put({
      type: DELETE_LOGS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_LOGS_FAILED, payload: { error: error } });
  }
}

function* getBOMDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BOM_DETAILS_FAILED, payload: { error: error } });
  }
}

function* getBOMDetailsById(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/getBOMById",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_DETAILS_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BOM_DETAILS_BY_ID_FAILED, payload: { error: error } });
  }
}

function* getAllBOMDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/getAllBOMs",
      requestBody.payload
    );
    yield put({
      type: GET_ALL_BOM_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ALL_BOM_DETAILS_FAILED, payload: { error: error } });
  }
}

function* createBOMDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/createBOMDetails",
      requestBody.payload
    );
    yield put({
      type: CREATE_BOM_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_BOM_DETAILS_FAILED, payload: { error: error } });
  }
}

function* updateBOMDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/updateBOMDetails",
      requestBody.payload
    );
    yield put({
      type: UPDATE_BOM_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_BOM_DETAILS_FAILED, payload: { error: error } });
  }
}

function* getItemsBOMDetails(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/getAllItemsBoms",
      requestBody.payload
    );
    yield put({
      type: GET_ITEMS_BOM_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ITEMS_BOM_DETAILS_FAILED, payload: { error: error } });
  }
}

function* deleteBOMDetails(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/deleteBOMDetails",
      requestBody.payload
    );
    yield put({
      type: DELETE_BOM_DETAILS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BOM_DETAILS_FAILED, payload: { error: error } });
  }
}

function* deleteBillOfMaterials(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/deleteBillOfMaterials",
      requestBody.payload
    );
    yield put({
      type: DELETE_BILL_OF_MATERIALS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BILL_OF_MATERIALS_FAILED, payload: { error: error } });
  }
}

function* editBillOfMaterials(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/editBillOfMaterials",
      requestBody.payload
    );
    yield put({
      type: EDIT_BILL_OF_MATERIALS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_BILL_OF_MATERIALS_FAILED, payload: { error: error } });
  }
}

function* duplicateBom(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/duplicateBom",
      requestBody.payload
    );
    yield put({
      type: DUPLICATE_BOM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DUPLICATE_BOM_FAILED, payload: { error: error } });
  }
}

function* bulkUploadBom(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomDetails/bulkUploadBom",
      requestBody.payload,
      true
    );
    yield put({
      type: BULK_UPLOAD_BOM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BULK_UPLOAD_BOM_FAILED, payload: { error: error } });
  }
}

function* createBOMProductionProcess(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomProductionProcess/createBOMProductionProcess",
      requestBody.payload
    );
    yield put({
      type: CREATE_BOM_PRODUCTION_PROCESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_BOM_PRODUCTION_PROCESS_FAILED, payload: { error: error } });
  }
}

function* getBOMProductionProcess(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomProductionProcess",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_PRODUCTION_PROCESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BOM_PRODUCTION_PROCESS_FAILED, payload: { error: error } });
  }
}

function* updateBOMProductionProcess(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomProductionProcess/updateBOMProductionProcess",
      requestBody.payload
    );
    yield put({
      type: UPDATE_BOM_PRODUCTION_PROCESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_BOM_PRODUCTION_PROCESS_FAILED, payload: { error: error } });
  }
}

function* deleteBOMProductionProcess(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomProductionProcess/deleteBOMProductionProcess",
      requestBody.payload
    );
    yield put({
      type: DELETE_BOM_PRODUCTION_PROCESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BOM_PRODUCTION_PROCESS_FAILED, payload: { error: error } });
  }
}

function* getBOMFinishedGoods(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomFinishedGoods",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_FINISHED_GOODS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_BOM_FINISHED_GOODS_FAILED,
      payload: { error: error },
    });
  }
}

function* addBOMFinishedGoods(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomFinishedGoods/addBOMFinishedGoods",
      requestBody.payload
    );
    yield put({
      type: ADD_BOM_FINISHED_GOODS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_BOM_FINISHED_GOODS_FAILED, payload: { error: error } });
  }
}

function* updateBOMFinishedGoods(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomFinishedGoods/updateBOMFinishedGoods",
      requestBody.payload
    );
    yield put({
      type: UPDATE_BOM_FINISHED_GOODS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_BOM_FINISHED_GOODS_FAILED, payload: { error: error } });
  }
}

function* deleteBOMFinishedGoods(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomFinishedGoods/deleteBOMFinishedGoods",
      requestBody.payload
    );
    yield put({
      type: DELETE_BOM_FINISHED_GOODS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BOM_FINISHED_GOODS_FAILED, payload: { error: error } });
  }
}

function* getBOMRawMaterials(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomRawMaterials",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_RAW_MATERIALS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_BOM_RAW_MATERIALS_FAILED,
      payload: { error: error },
    });
  }
}

function* addBOMRawMaterials(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomRawMaterials/addBOMRawMaterials",
      requestBody.payload
    );
    yield put({
      type: ADD_BOM_RAW_MATERIALS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_BOM_RAW_MATERIALS_FAILED, payload: { error: error } });
  }
}

function* updateBOMRawMaterials(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomRawMaterials/updateBOMRawMaterials",
      requestBody.payload
    );
    yield put({
      type: UPDATE_BOM_RAW_MATERIALS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_BOM_RAW_MATERIALS_FAILED, payload: { error: error } });
  }
}

function* deleteBOMRawMaterials(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomRawMaterials/deleteBOMRawMaterials",
      requestBody.payload
    );
    yield put({
      type: DELETE_BOM_RAW_MATERIALS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BOM_RAW_MATERIALS_FAILED, payload: { error: error } });
  }
}

function* issueRawMaterial(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/issueRawMaterial",
      requestBody.payload
    );
    yield put({
      type: ISSUE_RAW_MATERIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ISSUE_RAW_MATERIAL_FAILED, payload: { error: error } });
  }
}

function* updateProcess(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/updateProcess",
      requestBody.payload
    );
    yield put({
      type: UPDATE_PROCESS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_PROCESS_FAILED, payload: { error: error } });
  }
}

function* updateCost(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/updateCost",
      requestBody.payload
    );
    yield put({
      type: UPDATE_COST_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_COST_FAILED, payload: { error: error } });
  }
}

function* saveFinishedGoods(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/saveFinishedGoods",
      requestBody.payload
    );
    yield put({
      type: SAVE_FINISHED_GOODS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SAVE_FINISHED_GOODS_FAILED, payload: { error: error } });
  }
}

function* saveRework(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/saveReworkQuantity",
      requestBody.payload
    );
    yield put({
      type: SAVE_REWORK_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SAVE_REWORK_FAILED, payload: { error: error } });
  }
}

function* updateProductionStatus(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/updateProductionStatus",
      requestBody.payload
    );
    yield put({
      type: UPDATE_PRODUCTION_STATUS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_PRODUCTION_STATUS_FAILED, payload: { error: error } });
  }
}

function* updateScrapLogs(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/updateScrapLogs",
      requestBody.payload
    );
    yield put({
      type: UPDATE_SCRAP_LOGS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_SCRAP_LOGS_FAILED, payload: { error: error } });
  }
}

function* saveProduction(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/saveProduction",
      requestBody.payload
    );
    yield put({
      type: SAVE_PRODUCTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SAVE_PRODUCTION_FAILED, payload: { error: error } });
  }
}

function* materialPlanning(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/materialPlanning",
      requestBody.payload
    );
    yield put({
      type: MATERIAL_PLANNING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: MATERIAL_PLANNING_FAILED, payload: { error: error } });
  }
}

function* minStockMaterialPlanning(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/minStockMaterialPlanning",
      requestBody.payload
    )
    yield put({
      type: MIN_STOCK_MATERIAL_PLANNING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: MIN_STOCK_MATERIAL_PLANNING_FAILED, payload: { error: error } });
  }
}

function* bomBasedMaterialPlanning(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/bomBasedMaterialPlanning",
      requestBody.payload
    );
    yield put({
      type: BOM_BASED_MATERIAL_PLANNING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BOM_BASED_MATERIAL_PLANNING_FAILED, payload: { error: error } });
  }
}

function* getProductionsByCompanyId(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/getProductionsByCompanyId",
      requestBody.payload
    );
    yield put({
      type: GET_PRODUCTIONS_BY_COMPANY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_PRODUCTIONS_BY_COMPANY_ID_FAILED, payload: { error: error } });
  }
}

function* productionBasedMaterialPlanning(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/productionBasedMaterialPlanning",
      requestBody.payload
    );
    yield put({
      type: PRODUCTION_BASED_MATERIAL_PLANNING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: PRODUCTION_BASED_MATERIAL_PLANNING_FAILED, payload: { error: error } });
  }
}

function* updateTable(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/updateTable",
      requestBody.payload
    );
    yield put({
      type: UPDATE_TABLE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_TABLE_FAILED, payload: { error: error } });
  }
}

function* removeRows(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/removeRows",
      requestBody.payload
    );
    yield put({
      type: REMOVE_ROWS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: REMOVE_ROWS_FAILED, payload: { error: error } });
  }
}

function* viewProductionHistory(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/viewProductionHistory",
      requestBody.payload
    );
    yield put({
      type: VIEW_PRODUCTION_HISTORY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: VIEW_PRODUCTION_HISTORY_FAILED, payload: { error: error } });
  }
}

function* returnRawMaterial(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/returnRawMaterial",
      requestBody.payload
    );
    yield put({
      type: RETURN_RAW_MATERIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: RETURN_RAW_MATERIAL_FAILED, payload: { error: error } });
  }
}

function* linkBom(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomRawMaterials/linkBom",
      requestBody.payload
    );
    yield put({
      type: LINK_BOM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: LINK_BOM_FAILED, payload: { error: error } });
  }
}

function* unlinkBom(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomRawMaterials/unlinkBom",
      requestBody.payload
    );
    yield put({
      type: UNLINK_BOM_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UNLINK_BOM_FAILED, payload: { error: error } });
  }
}

function* getBOMScrapLogs(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomScrapMaterials",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_SCRAP_LOG_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_BOM_SCRAP_LOG_FAILED,
      payload: { error: error },
    });
  }
}

function* addBOMScrapLogs(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomScrapMaterials/addScrapMaterials",
      requestBody.payload
    );
    yield put({
      type: ADD_BOM_SCRAP_LOG_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_BOM_SCRAP_LOG_FAILED, payload: { error: error } });
  }
}

function* updateBOMScrapLogs(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomScrapMaterials/updateScrapMaterials",
      requestBody.payload
    );
    yield put({
      type: UPDATE_BOM_SCRAP_LOG_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_BOM_SCRAP_LOG_FAILED, payload: { error: error } });
  }
}

function* deleteBOMScrapLogs(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomScrapMaterials/deleteScrapMaterials",
      requestBody.payload
    );
    yield put({
      type: DELETE_BOM_SCRAP_LOG_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BOM_SCRAP_LOG_FAILED, payload: { error: error } });
  }
}

function* getBOMAdditionalCharges(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomAdditionalCharges",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_ADDITIONAL_CHARGES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_BOM_ADDITIONAL_CHARGES_FAILED,
      payload: { error: error },
    });
  }
}

function* addBOMAdditionalCharges(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomAdditionalCharges/createBOMAdditionalCharges",
      requestBody.payload
    );
    yield put({
      type: ADD_BOM_ADDITIONAL_CHARGES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_BOM_ADDITIONAL_CHARGES_FAILED, payload: { error: error } });
  }
}

function* updateBOMAdditionalCharges(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomAdditionalCharges/updateBOMAdditionalCharges",
      requestBody.payload
    );
    yield put({
      type: UPDATE_BOM_ADDITIONAL_CHARGES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_BOM_ADDITIONAL_CHARGES_FAILED, payload: { error: error } });
  }
}

function* deleteBOMAdditionalCharges(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "bomAdditionalCharges/deleteBOMAdditionalCharges",
      requestBody.payload
    );
    yield put({
      type: DELETE_BOM_ADDITIONAL_CHARGES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BOM_ADDITIONAL_CHARGES_FAILED, payload: { error: error } });
  }
}

function* getLogPayments(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "logPayments",
      requestBody.payload
    );
    yield put({
      type: GET_LOG_PAYMENTS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_LOG_PAYMENTS_FAILED,
      payload: { error: error },
    });
  }
}

function* getLogPaymentById(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "logPayments/:id",
      requestBody.payload
    );
    yield put({
      type: GET_LOG_PAYMENT_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_LOG_PAYMENT_BY_ID_FAILED,
      payload: { error: error },
    });
  }
}

function* addLogPayments(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "logPayments/addLogPayments",
      requestBody.payload
    );
    yield put({
      type: ADD_LOG_PAYMENTS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_LOG_PAYMENTS_FAILED, payload: { error: error } });
  }
}

function* updateLogPayments(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "logPayments/updateLogPayments",
      requestBody.payload
    );
    yield put({
      type: UPDATE_LOG_PAYMENTS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_LOG_PAYMENTS_FAILED, payload: { error: error } });
  }
}

function* deleteLogPayments(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "logPayments/deleteLogPayment",
      requestBody.payload
    );
    yield put({
      type: DELETE_LOG_PAYMENTS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_LOG_PAYMENTS_FAILED, payload: { error: error } });
  }
}

function* getLogTDS(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "logTDS",
      requestBody.payload
    );
    yield put({
      type: GET_LOG_TDS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_LOG_TDS_FAILED,
      payload: { error: error },
    });
  }
}

function* getLogTDSById(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "logTDS/:id",
      requestBody.payload
    );
    yield put({
      type: GET_LOG_TDS_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({
      type: GET_LOG_TDS_BY_ID_FAILED,
      payload: { error: error },
    });
  }
}

function* addLogTDS(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "logTDS/addLogTDS",
      requestBody.payload
    );
    yield put({
      type: ADD_LOG_TDS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_LOG_TDS_FAILED, payload: { error: error } });
  }
}

function* updateLogTDS(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "logTDS/updateLogTDS",
      requestBody.payload
    );
    yield put({
      type: UPDATE_LOG_TDS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_LOG_TDS_FAILED, payload: { error: error } });
  }
}

function* deleteLogTDS(requestBody) {
  console.log(requestBody.payload);
  try {
    const response = yield call(
      postApiWorker,
      "logTDS/deleteLogTDS",
      requestBody.payload
    );
    yield put({
      type: DELETE_LOG_TDS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_LOG_TDS_FAILED, payload: { error: error } });
  }
}

function* startProduction(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/startProduction",
      requestBody.payload
    );
    yield put({
      type: START_PRODUCTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: START_PRODUCTION_FAILED, payload: { error: error } });
  }
}

function* startBulkProduction(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/startBulkProduction",
      requestBody.payload
    );
    yield put({
      type: START_BULK_PRODUCTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: START_BULK_PRODUCTION_FAILED, payload: { error: error } });
  }
}

function* getProductions(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/getProductions",
      requestBody.payload
    );
    yield put({
      type: GET_PRODUCTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_PRODUCTION_FAILED, payload: { error: error } });
  }
}

function* getProductionById(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/getProductionById",
      requestBody.payload
    );
    yield put({
      type: GET_PRODUCTION_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_PRODUCTION_BY_ID_FAILED, payload: { error: error } });
  }
}

function* getBulkProduction(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/bulkGetProductionsByIds",
      requestBody.payload
    );
    yield put({
      type: GET_BULK_PRODUCTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BULK_PRODUCTION_FAILED, payload: { error: error } });
  }
}

function* getBulkProductions(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/getBulkProductions",
      requestBody.payload
    );
    yield put({
      type: GET_BULK_PRODUCTIONS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BULK_PRODUCTIONS_FAILED, payload: { error: error } });
  }
}

function* getRemainingProduction(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/remainingProduction",
      requestBody.payload
    );
    yield put({
      type: GET_REMAINING_PRODUCTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_REMAINING_PRODUCTION_FAILED, payload: { error: error } });
  }
}

function* discardProduction(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/discardProduction",
      requestBody.payload
    );
    yield put({
      type: DISCARD_PRODUCTION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DISCARD_PRODUCTION_FAILED, payload: { error: error } });
  }
}

function* bulkIssue(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/bulkIssue",
      requestBody.payload
    );
    yield put({
      type: BULK_ISSUE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BULK_ISSUE_FAILED, payload: { error: error } });
  }
}

function* updateStartDate(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "production/updateStartDate",
      requestBody.payload
    );
    yield put({
      type: UPDATE_START_DATE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_START_DATE_FAILED, payload: { error: error } });
  }
}

function* bulkUploadCompany(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "buyerSupplier/addBulkCompany",
      requestBody.payload,
      true
    );
    yield put({
      type: BULK_UPLOAD_BUYER_SUPPLIER_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: BULK_UPLOAD_BUYER_SUPPLIER_FAILED, payload: { error: error } });
  }
}


function* getAllRejectStoreItems(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/getAllRejectStoreItems",
      requestBody.payload
    );
    yield put({
      type: GET_ALL_REJECT_STORE_ITEMS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ALL_REJECT_STORE_ITEMS_FAILED, payload: { error: error } });
  }
}

function* getReports(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "reports/getReports",
      requestBody.payload
    );
    yield put({
      type: GET_REPORTS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_REPORTS_FAILED, payload: { error: error } });
  }
}

function* addLabel(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "labels/addLabel",
      requestBody.payload
    );
    yield put({
      type: ADD_LABEL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_LABEL_FAILED, payload: { error: error } });
  }
}

function* getLabels(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "labels/getLabels",
      requestBody.payload
    );
    yield put({
      type: GET_LABELS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_LABELS_FAILED, payload: { error: error } });
  }
}

function* editLabel(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "labels/editLabel",
      requestBody.payload
    );
    yield put({
      type: EDIT_LABEL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_LABEL_FAILED, payload: { error: error } });
  }
}

function* deleteLabel(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "labels/deleteLabel",
      requestBody.payload
    );
    yield put({
      type: DELETE_LABEL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_LABEL_FAILED, payload: { error: error } });
  }
}

function* assignLabels(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "labels/assignLabels",
      requestBody.payload
    );
    yield put({
      type: ASSIGN_LABELS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ASSIGN_LABELS_FAILED, payload: { error: error } });
  }
}

function* removeLabel(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "labels/removeLabel",
      requestBody.payload
    );
    yield put({
      type: REMOVE_LABEL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: REMOVE_LABEL_FAILED, payload: { error: error } });
  }
}

function* getSetting(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "settings/getSetting",
      requestBody.payload
    );
    yield put({
      type: GET_SETTING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_SETTING_FAILED, payload: { error: error } });
  }
}

function* updateSetting(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "settings/updateSetting",
      requestBody.payload
    );
    yield put({
      type: UPDATE_SETTING_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_SETTING_FAILED, payload: { error: error } });
  }
}

function* getFifoPrice(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "stores/getFifoPrice",
      requestBody.payload
    );
    yield put({
      type: GET_FIFO_PRICE_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_FIFO_PRICE_FAILED, payload: { error: error } });
  }
}

function* setApprovalPermission(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documentApproval/setApproval",
      requestBody.payload
    );
    yield put({
      type: SET_APPROVAL_PERMISSION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SET_APPROVAL_PERMISSION_FAILED, payload: { error: error } });
  }
}

function* getApprovalPermission(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documentApproval/",
      requestBody.payload
    );
    yield put({
      type: GET_APPROVAL_PERMISSION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_APPROVAL_PERMISSION_FAILED, payload: { error: error } });
  }
}

function* deleteApprovalPermission(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documentApproval/deletePermission",
      requestBody.payload
    );
    yield put({
      type: DELETE_APPROVAL_PERMISSION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_APPROVAL_PERMISSION_FAILED, payload: { error: error } });
  }
}

function* approveDocument(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "documents/approveDocument",
      requestBody.payload
    );
    yield put({
      type: APPROVED_DOCUMENT_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: APPROVED_DOCUMENT_FAILED, payload: { error: error } });
  }
}

function* getInventoryApprovals(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "inventoryApproval/getInventoryApprovals",
      requestBody.payload
    );
    yield put({
      type: GET_INVENTORY_APPROVAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_INVENTORY_APPROVAL_FAILED, payload: { error: error } });
  }
}

function* getInventoryApprovalById(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "inventoryApproval/getInventoryApprovalById",
      requestBody.payload
    );
    yield put({
      type: GET_INVENTORY_APPROVAL_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_INVENTORY_APPROVAL_BY_ID_FAILED, payload: { error: error } });
  }
}

function* acceptRejectInventoryApproval(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "inventoryApproval/acceptRejectApproval",
      requestBody.payload
    );
    yield put({
      type: ACCEPT_REJECT_APPROVAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ACCEPT_REJECT_APPROVAL_FAILED, payload: { error: error } });
  }
}

function* getBOMApprovals(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomApproval/getBOMApprovals",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_APPROVALS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BOM_APPROVALS_FAILED, payload: { error: error } });
  }
}

function* getBOMApprovalById(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomApproval/getBOMApprovalById",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_APPROVAL_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BOM_APPROVAL_BY_ID_FAILED, payload: { error: error } });
  }
}

function* acceptRejectBOMApproval(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomApproval/acceptRejectApproval",
      requestBody.payload
    );
    yield put({
      type: ACCEPT_REJECT_BOM_APPROVAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ACCEPT_REJECT_BOM_APPROVAL_FAILED, payload: { error: error } });
  }
}

function* setBOMApprovalPermission(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomApproval/setApprovalPermission",
      requestBody.payload
    );
    yield put({
      type: SET_BOM_APPROVAL_PERMISSION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: SET_BOM_APPROVAL_PERMISSION_FAILED, payload: { error: error } });
  }
}

function* getBOMApprovalPermission(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomApproval/getApprovalPermission",
      requestBody.payload
    );
    yield put({
      type: GET_BOM_APPROVAL_PERMISSION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_BOM_APPROVAL_PERMISSION_FAILED, payload: { error: error } });
  }
}

function* deleteBOMApprovalPermission(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "bomApproval/deleteApprovalPermission",
      requestBody.payload
    );
    yield put({
      type: DELETE_BOM_APPROVAL_PERMISSION_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_BOM_APPROVAL_PERMISSION_FAILED, payload: { error: error } });
  }
}

function* createEInvoiceCredential(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "eInvoice/createCredential",
      requestBody.payload
    );
    yield put({
      type: CREATE_EINVOICE_CREDENTIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_EINVOICE_CREDENTIAL_FAILED, payload: { error: error } });
  }
}

function* getEInvoiceCredential(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "eInvoice/getCredential",
      requestBody.payload
    );
    yield put({
      type: GET_EINVOICE_CREDENTIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_EINVOICE_CREDENTIAL_FAILED, payload: { error: error } });
  }
}

function* updateEInvoiceCredential(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "eInvoice/updateCredential",
      requestBody.payload
    );
    yield put({
      type: UPDATE_EINVOICE_CREDENTIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_EINVOICE_CREDENTIAL_FAILED, payload: { error: error } });
  }
}

function* deleteEInvoiceCredential(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "eInvoice/deleteCredential",
      requestBody.payload
    );
    yield put({
      type: DELETE_EINVOICE_CREDENTIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_EINVOICE_CREDENTIAL_FAILED, payload: { error: error } });
  }
}

function* createEmailCredential(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "email/createEmailCredential",
      requestBody.payload
    );
    yield put({
      type: CREATE_EMAIL_CREDENTIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_EMAIL_CREDENTIAL_FAILED, payload: { error: error } });
  }
}

function* getEMailCredential(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "email/getEmailCredential",
      requestBody.payload
    );
    yield put({
      type: GET_EMAIL_CREDENTIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_EMAIL_CREDENTIAL_FAILED, payload: { error: error } });
  }
}

function* updateEMailCredential(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "email/updateEmailCredential",
      requestBody.payload
    );
    yield put({
      type: UPDATE_EMAIL_CREDENTIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: UPDATE_EMAIL_CREDENTIAL_FAILED, payload: { error: error } });
  }
}

function* deleteEMailCredential(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "email/deleteEmailCredential",
      requestBody.payload
    );
    yield put({
      type: DELETE_EMAIL_CREDENTIAL_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_EMAIL_CREDENTIAL_FAILED, payload: { error: error } });
  }
}

function* amyCompletions(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "amy/completions",
      requestBody.payload
    );
    yield put({
      type: COMPLETIONS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: COMPLETIONS_FAILED, payload: { error: error } });
  }
}

function* amyReports(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "amy/report",
      requestBody.payload
    );
    yield put({
      type: REPORTS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: REPORTS_FAILED, payload: { error: error } });
  }
}

function* getAllColumns(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "showHideColumns/getColumns",
      requestBody.payload
    );
    yield put({
      type: GET_COLUMNS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_COLUMNS_FAILED, payload: { error: error } });
  }
}

function* addColumns(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "showHideColumns/addColumns",
      requestBody.payload
    );
    yield put({
      type: ADD_COLUMNS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: ADD_COLUMNS_FAILED, payload: { error: error } });
  }
}

function* editColumns(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "showHideColumns/editColumns",
      requestBody.payload
    );
    yield put({
      type: EDIT_COLUMNS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: EDIT_COLUMNS_FAILED, payload: { error: error } });
  }
}

function* deleteColumns(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "showHideColumns/deleteColumns",
      requestBody.payload
    );
    yield put({
      type: DELETE_COLUMNS_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: DELETE_COLUMNS_FAILED, payload: { error: error } });
  }
}

function* getGateEntriesById(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "gateEntry/getGateEntriesById",
      requestBody.payload
    );
    yield put({
      type: GET_GATE_ENTRIES_BY_ID_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_GATE_ENTRIES_BY_ID_FAILED, payload: { error: error } });
  }
}

function* getAllGateEntries(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "gateEntry/getAllGateEntries",
      requestBody.payload
    );
    yield put({
      type: GET_ALL_GATE_ENTRIES_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: GET_ALL_GATE_ENTRIES_FAILED, payload: { error: error } });
  }
}

function* updateGateEntry(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "gateEntry/updateGateEntry",
      requestBody.payload
    );
    yield put({
      type: UPDATE_GATE_ENTRY_SUCCESS,
      payload: { responseData: response },
    });
  }
  catch (error) {
    yield put({ type: UPDATE_GATE_ENTRY_FAILED, payload: { error: error } });
  }
}

function* createGateEntry(requestBody) {
  try {
    const response = yield call(
      postApiWorker,
      "gateEntry/createGateEntry",
      requestBody.payload
    );
    yield put({
      type: CREATE_GATE_ENTRY_SUCCESS,
      payload: { responseData: response },
    });
  } catch (error) {
    yield put({ type: CREATE_GATE_ENTRY_FAILED, payload: { error: error } });
  }
}

function* easeMarginSagas() {
  yield takeEvery(LOGIN_USER, login);
  yield takeEvery(SIGNUP_USER, signupUser);
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
  yield takeEvery(RESET_PASSWORD, resetPassword);

  yield takeEvery(ADD_BLOG, addBlog);
  yield takeEvery(EDIT_BLOG, editBlog);
  yield takeEvery(GET_BLOG_BY_ID, getBlogById);
  yield takeEvery(GET_BLOGS, getBlogs);
  yield takeEvery(DELETE_BLOG, deleteBlog);
  yield takeEvery(GET_BLOGS_CATEGORIES, getBlogsCategories);
  yield takeEvery(BLOGS_SEARCH, blogsSearch);

  yield takeEvery(ADD_STORE, addStore);
  yield takeEvery(GET_STORE, getStores);
  yield takeEvery(GET_STORE_BY_ID, getStoreById);
  yield takeEvery(GET_STORE_BY_ITEMS, getStoreByItems);
  yield takeEvery(EDIT_STORE, editStore);
  yield takeEvery(GET_ALL_STOCKS_VALUES, getAllStockValues);
  yield takeEvery(DELETE_STORE, deleteStore);
  yield takeEvery(GET_STORE_BY_ITEM, getStoreByItem);
  yield takeEvery(GET_ALL_STORE_ITEMS_BY_STORES_ID, getAllStoreItemsByStoresID);
  yield takeEvery(GET_ALL_STORES_WITH_ITEMS, getAllStoresWithItems);
  yield takeEvery(SET_DEFAULT_STORE, setDefaultStore);

  yield takeEvery(ADD_ADDRESS, addAddress);
  yield takeEvery(GET_ADDRESS, getAddress);
  yield takeEvery(EDIT_ADDRESS, editAddress);
  yield takeEvery(DELETE_ADDRESS, deleteAddress);
  yield takeEvery(SET_DEFAULT_ADDRESS, setDefaultAddress);
  yield takeEvery(UPLOAD_IMAGE, uploadImage);

  yield takeEvery(GET_TEAMS, getTeams);
  yield takeEvery(ADD_TEAM, addTeam);
  yield takeEvery(EDIT_TEAM, editTeam);
  yield takeEvery(DELETE_TEAM, deleteTeam);

  yield takeEvery(GET_UOM, getUom);
  yield takeEvery(ADD_UOM, addUom);
  yield takeEvery(EDIT_UOM, editUom);
  yield takeEvery(DELETE_UOM, deleteUom);

  yield takeEvery(GET_PACKAGING_MASTER, getPackagingMaster);
  yield takeEvery(ADD_PACKAGING_MASTER, addPackagingMaster);
  yield takeEvery(EDIT_PACKAGING_MASTER, editPackagingMaster);
  yield takeEvery(DELETE_PACKAGING_MASTER, deletePackagingMaster);

  yield takeEvery(GET_ITEM_MAPPING, getItemMapping);
  yield takeEvery(ADD_ITEM_MAPPING, addItemMapping);
  yield takeEvery(EDIT_ITEM_MAPPING, editItemMapping);
  yield takeEvery(DELETE_ITEM_MAPPING, deleteItemMapping);

  yield takeEvery(GET_CATEGORY, getCategory);
  yield takeEvery(ADD_CATEGORY, addCategory);
  yield takeEvery(EDIT_CATEGORY, editCategory);
  yield takeEvery(DELETE_CATEGORY, deleteCategory);

  yield takeEvery(GET_USERS, getUsers);
  yield takeEvery(ADD_USER, addUser);
  yield takeEvery(EDIT_USER, editUser);
  yield takeEvery(DELETE_USER, deleteUser);
  yield takeEvery(UPDATE_USER, updateUser);
  yield takeEvery(UPDATE_PROFILE_LOGO, updateProfileLogo);
  yield takeEvery(UPDATE_SIGNATURE, updateSignature);
  yield takeEvery(GET_PARTIAL_USER, getPartialUser);
  yield takeEvery(GET_COMPANIES, getCompanies);
  yield takeEvery(DELETE_COMPANIES_DATA, deleteCompaniesData);

  yield takeEvery(ADD_COMMENT, addBlogComment);
  yield takeEvery(DELETE_COMMENT, deleteBlogComment);
  yield takeEvery(APPROVE_COMMENT, approveComments);
  yield takeEvery(GET_APPROVE_BLOG_COMMENT, getApprovedBlogComments);
  yield takeEvery(GET_BLOG_COMMENTS_TO_BE_APPROVED, getBlogCommentstoBeApprove);
  yield takeEvery(GET_ALL_BLOGS_APPROVED_COMMENTS, getAllBlogsApprovedComments);

  yield takeEvery(GET_ITEMS, getItems);
  yield takeEvery(GET_ITEMS_PAGINATED, getPaginatedItems);
  yield takeEvery(ADD_ITEM, addItem);
  yield takeEvery(EDIT_ITEM, editItem);
  yield takeEvery(DELETE_ITEM, deleteItem);
  yield takeEvery(BULK_DELETE_ITEM, bulkDeleteItem);
  yield takeEvery(BULK_UPLOAD_ITEM, bulkUploadItem);
  yield takeEvery(BULK_EDIT_ITEM, bulkEditItem);
  yield takeEvery(BULK_RECONCILATION_ITEM, bulkReconcilationItem);
  yield takeEvery(BULK_UPLOAD_ALTERNATE_UNIT, bulkUploadAlternateUnit);
  yield takeEvery(GET_LAST_UPDATED_PRICE, getLastUpdatedPrice);

  yield takeEvery(ADD_BUYER_SUPPLIER, addBuyerSupplier);
  yield takeEvery(GET_BUYER_SUPPLIER, getBuyerSupplier);
  yield takeEvery(EDIT_BUYER_SUPPLIER, editBuyerSupplier);
  yield takeEvery(DELETE_BUYER_SUPPLIER, deleteBuyerSupplier);
  yield takeEvery(BULK_DELETE_BUYER_SUPPLIER, bulkDeleteBuyerSupplier);
  yield takeEvery(BULK_UPLOAD_BUYER_SUPPLIER, bulkUploadCompany);
  yield takeEvery(GET_COMPANY_DETAILS_BY_GSTN, getCompanyDetailsByGstn);

  yield takeEvery(GET_DOCUMENT_SERIES, getDocumentSeries);
  yield takeEvery(ADD_DOCUMENT_SERIES, addDocumentSeries);
  yield takeEvery(EDIT_DOCUMENT_SERIES, editDocumentSeries);
  yield takeEvery(DELETE_DOCUMENT_SERIES, deleteDocumentSeries);
  yield takeEvery(SHORT_CLOSE_TRANSACTION, shortCloseTransaction);
  yield takeEvery(GET_SALES_DOCUMENTS_ITEMS, getSalesDocumentItems);

  yield takeEvery(GET_BOM_SERIES, getBOMSeries);
  yield takeEvery(ADD_BOM_SERIES, addBOMSeries);
  yield takeEvery(EDIT_BOM_SERIES, editBOMSeries);
  yield takeEvery(DELETE_BOM_SERIES, deleteBOMSeries);
  yield takeEvery(UPDATE_LAST_BOM_NUMBER, updateLastBOMNumber);
  yield takeEvery(SET_DEFAULT_BOM_SERIES, setDefaultBOMSeries);

  yield takeEvery(GET_ITEM_SERIES, getItemSeries);
  yield takeEvery(ADD_ITEM_SERIES, addItemSeries);
  yield takeEvery(EDIT_ITEM_SERIES, editItemSeries);
  yield takeEvery(DELETE_ITEM_SERIES, deleteItemSeries);
  yield takeEvery(UPDATE_LAST_ITEM_NUMBER, updateLastItemNumber);
  yield takeEvery(SET_DEFAULT_ITEM_SERIES, setDefaultItemSeries);

  yield takeEvery(PREVIEW_DOCUMENT, previewDocument);
  yield takeEvery(UPDATE_LAST_DOCUMENT_NUMBER, updateLastDocumentNumber);
  yield takeEvery(GET_DOCUMENT_ITEMS, getDocumentItems);
  yield takeEvery(SET_DEFAULT_SERIES, setDefaultSeries);
  yield takeEvery(GET_CHALLAN_ITEMS, getChallanItems);

  yield takeEvery(GET_BANK_DETAIL, getBankDetail);
  yield takeEvery(ADD_BANK_DETAIL, addBankDetail);
  yield takeEvery(EDIT_BANK_DETAIL, editBankDetail);
  yield takeEvery(DELETE_BANK_DETAIL, deleteBankDetail);

  yield takeEvery(GET_DOCUMENTS, getDocuments);
  yield takeEvery(GET_DOCUMENTS_BY_ID, getDocumentById);
  yield takeEvery(FETCH_CURRENT_DOC, fetchCurrentDoc);
  yield takeEvery(CREATE_DOCUMENT, createDocument);
  yield takeEvery(CREATE_EINVOICE, createEInvoice);
  yield takeEvery(CREATE_EWAYBILL, createEWayBill);
  yield takeEvery(EMAIL_DOCUMENT, emailDocument);
  yield takeEvery(CANCEL_EINVOICE, cancelEInvoice);
  yield takeEvery(CANCEL_EWAYBILL, cancelEWayBill);
  yield takeEvery(CREATE_EWAYBILL_FROM_EINVOICE, createEWayBillFromEInvoice);

  yield takeEvery(CHANGE_APPROVAL_STATUS, changeApprovalStatus);
  yield takeEvery(GET_APPROVAL_HISTORY, getApprovalHistory);
  yield takeEvery(GET_DOCUMENTS_BY_STATUS, getDocumentsByStatus);

  yield takeEvery(EDIT_DOCUMENT, editDocument);
  yield takeEvery(SAVE_RFQ_QUOTATION, saveRfqQuotation);
  yield takeEvery(DISCARD_DOCUMENT, discardDocument);
  yield takeEvery(DELETE_DOCUMENT, deleteDocument);

  yield takeEvery(NOTIFY, notify);
  yield takeEvery(GET_NOTIFICATIONS, getNotifications);

  yield takeEvery(GET_ACCOUNT_INFO, getAccountInfo);
  yield takeEvery(UPDATE_ACCOUNT_INFO, updateAccountInfo);

  yield takeEvery(STOCK_TRANSFER, stockTransfer);
  yield takeEvery(STOCK_UPDATE, stockUpdate);
  yield takeEvery(ITEM_STOCK_TRANSFER_HISTORY, itemStockTransferHistory);
  yield takeEvery(STOCK_TRANSFER_HISTORY, stockTransferHistory);

  yield takeEvery(STOCK_RECONCILE, stockReconcile);

  yield takeEvery(GET_PAYMENT_TERMS, getPaymentTerm);
  yield takeEvery(ADD_PAYMENT_TERMS, addPaymentTerm);
  yield takeEvery(EDIT_PAYMENT_TERMS, editPaymentTerm);
  yield takeEvery(DELETE_PAYMENT_TERMS, deletePaymentTerm);

  yield takeEvery(GET_LOGISTIC_DETAILS, getLogisticDetails);
  yield takeEvery(ADD_LOGISTIC_DETAILS, addLogisticDetails);
  yield takeEvery(EDIT_LOGISTIC_DETAILS, editLogisticDetails);
  yield takeEvery(DELETE_LOGISTIC_DETAILS, deleteLogisticDetails);

  yield takeEvery(GET_TRANSPORTER_DETAILS, getTransporterDetails);
  yield takeEvery(ADD_TRANSPORTER_DETAILS, addTransporterDetails);
  yield takeEvery(EDIT_TRANSPORTER_DETAILS, editTransporterDetails);
  yield takeEvery(DELETE_TRANSPORTER_DETAILS, deleteTransporterDetails);

  yield takeEvery(REPORT_COLUMNS_PREFRENCE, reportColumnslPrefrence);

  yield takeEvery(ADD_LABEL, addLabel);
  yield takeEvery(GET_LABELS, getLabels);
  yield takeEvery(EDIT_LABEL, editLabel);
  yield takeEvery(DELETE_LABEL, deleteLabel);
  yield takeEvery(ASSIGN_LABELS, assignLabels);
  yield takeEvery(REMOVE_LABEL, removeLabel);

  yield takeEvery(GET_TERMS_CONDITION, getTermsCondition);
  yield takeEvery(ADD_TERMS_CONDITION, addTermsCondition);
  yield takeEvery(EDIT_TERMS_CONDITION, editTermsCondition);
  yield takeEvery(DELETE_TERMS_CONDITION, deleteTermsCondition);

  yield takeEvery(GET_CUSTOM_FIELDS, getCustomFields);
  yield takeEvery(ADD_CUSTOM_FIELDS, addCustomFields);
  yield takeEvery(EDIT_CUSTOM_FIELDS, editCustomFields);
  yield takeEvery(DELETE_CUSTOM_FIELDS, deleteCustomFields);
  yield takeEvery(EDIT_PERMISSIONS, editPermission);
  yield takeEvery(EDIT_CUSTOM_FIELD, editCustomField);

  yield takeEvery(GET_CUSTOM_FORMS, getCustomForms);
  yield takeEvery(ADD_CUSTOM_FORMS, addCustomForms);
  yield takeEvery(EDIT_CUSTOM_FORMS, editCustomForms);
  yield takeEvery(DELETE_CUSTOM_FORMS, deleteCustomForms);

  yield takeEvery(GET_CONTACT_US, getContactUs);
  yield takeEvery(ADD_CONTACT_US, addContactUs);

  yield takeEvery(ADD_REQUEST_DEMO_QUERY_DATA, addDemoQueryData);
  yield takeEvery(GET_REQUEST_DEMO_QUERY_DATA, getDemoQueryData);

  yield takeEvery(ADD_NEWS_LETTERS, addNewsLetters);
  yield takeEvery(GET_NEWS_LETTERS, getNewsLetters);
  yield takeEvery(UNSUBSCRIBE_NEWS_LETTERS, unSubscribeNewsLetter);

  yield takeEvery(GET_INVENTORY_SERVICES, getInventoryService);
  yield takeEvery(ADD_INVENTORY_SERVICES, addInventoryService);
  yield takeEvery(EDIT_INVENTORY_SERVICES, editInventoryService);
  yield takeEvery(DELETE_INVENTORY_SERVICES, deleteInventoryService);

  yield takeEvery(CREATE_PRODUCTION_PROCESS, createProductionProcess);
  yield takeEvery(GET_PRODUCTION_PROCESS, getProductionProcess);
  yield takeEvery(GET_PRODUCTION_PROCESS_BY_ID, getProductionProcessById);
  yield takeEvery(UPDATE_PRODUCTION_PROCESS, updateProductionProcess);
  yield takeEvery(DELETE_PRODUCTION_PROCESS, deleteProductionProcess);
  yield takeEvery(GET_ALL_PRODUCTIONS, getAllProductions);
  yield takeEvery(DELETE_LOGS, deleteLogs);

  yield takeEvery(GET_BOM_DETAILS, getBOMDetails);
  yield takeEvery(GET_BOM_DETAILS_BY_ID, getBOMDetailsById);
  yield takeEvery(GET_ALL_BOM_DETAILS, getAllBOMDetails);
  yield takeEvery(CREATE_BOM_DETAILS, createBOMDetails);
  yield takeEvery(UPDATE_BOM_DETAILS, updateBOMDetails);
  yield takeEvery(DELETE_BOM_DETAILS, deleteBOMDetails);
  yield takeEvery(DELETE_BILL_OF_MATERIALS, deleteBillOfMaterials);
  yield takeEvery(EDIT_BILL_OF_MATERIALS, editBillOfMaterials);
  yield takeEvery(GET_ITEMS_BOM_DETAILS, getItemsBOMDetails);
  yield takeEvery(DUPLICATE_BOM, duplicateBom);
  yield takeEvery(BULK_UPLOAD_BOM, bulkUploadBom);

  yield takeEvery(CREATE_BOM_PRODUCTION_PROCESS, createBOMProductionProcess);
  yield takeEvery(GET_BOM_PRODUCTION_PROCESS, getBOMProductionProcess);
  yield takeEvery(UPDATE_BOM_PRODUCTION_PROCESS, updateBOMProductionProcess);
  yield takeEvery(DELETE_BOM_PRODUCTION_PROCESS, deleteBOMProductionProcess);

  yield takeEvery(GET_ITEMS_COUNT, getItemCount);
  yield takeEvery(GET_STORES_COUNT, getStoresCount);
  yield takeEvery(GET_USERS_COUNT, getUsersCount);
  yield takeEvery(GET_DOCUMENTS_COUNT, getDocumentsCount);
  yield takeEvery(GET_COMPANIES_COUNT, getCompaniesCount);
  yield takeEvery(GET_ITEMS_SALES_SUMMARY, getItemsSalesSummary);
  yield takeEvery(GET_INVOICE_SUMMARY, getInvoiceSummary);
  yield takeEvery(PREDICT_NEXT_VALUE, getPredictionValue);
  yield takeEvery(PREDICT_SALES, getSalesPrediction);
  yield takeEvery(GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION, getItemsSalesSummaryWithPrediction);
  yield takeEvery(GET_STORE_WISE_ITEMS, getStoreWiseItems);
  yield takeEvery(GET_CATEGORY_WISE_ITEMS, getCategoryWiseItems);
  yield takeEvery(FAST_MOVING_SLOW_MOVING_ITEMS, getFastMovingSlowMovingItems);
  yield takeEvery(STOCK_LEVEL_ANALYSIS, getStockLevelAnalysis);
  yield takeEvery(STOCK_AGEING, getStockAgeing);
  yield takeEvery(WORK_ORDER_STATUS, getWorkOrderStatus);
  yield takeEvery(ON_TIME_DELAY_PRODUCTION, getOnTimeDelayProduction);
  yield takeEvery(GET_SALES_DASHBOARD_DETAILS, getSalesDashboardDetails);
  yield takeEvery(GET_BATCHITEMS, getBatchItems);
  yield takeEvery(UPDATE_BATCHITEMS, updateBatchItems);
  yield takeEvery(CREATE_BATCHITEMS, createBatchItems);
  yield takeEvery(GET_DASHBOARD_DATA, getDashboardData);
  yield takeEvery(CREATE_SELECT_BATCHITEMS, createSelectBatchItems);


  yield takeEvery(GET_BOM_FINISHED_GOODS, getBOMFinishedGoods);
  yield takeEvery(ADD_BOM_FINISHED_GOODS, addBOMFinishedGoods);
  yield takeEvery(UPDATE_BOM_FINISHED_GOODS, updateBOMFinishedGoods);
  yield takeEvery(DELETE_BOM_FINISHED_GOODS, deleteBOMFinishedGoods);

  yield takeEvery(GET_BOM_RAW_MATERIALS, getBOMRawMaterials);
  yield takeEvery(ADD_BOM_RAW_MATERIALS, addBOMRawMaterials);
  yield takeEvery(UPDATE_BOM_RAW_MATERIALS, updateBOMRawMaterials);
  yield takeEvery(DELETE_BOM_RAW_MATERIALS, deleteBOMRawMaterials);

  yield takeEvery(GET_BOM_SCRAP_LOG, getBOMScrapLogs);
  yield takeEvery(ADD_BOM_SCRAP_LOG, addBOMScrapLogs);
  yield takeEvery(UPDATE_BOM_SCRAP_LOG, updateBOMScrapLogs);
  yield takeEvery(DELETE_BOM_SCRAP_LOG, deleteBOMScrapLogs);

  yield takeEvery(GET_BOM_ADDITIONAL_CHARGES, getBOMAdditionalCharges);
  yield takeEvery(ADD_BOM_ADDITIONAL_CHARGES, addBOMAdditionalCharges);
  yield takeEvery(UPDATE_BOM_ADDITIONAL_CHARGES, updateBOMAdditionalCharges);
  yield takeEvery(DELETE_BOM_ADDITIONAL_CHARGES, deleteBOMAdditionalCharges);

  yield takeEvery(GET_LOG_PAYMENTS, getLogPayments);
  yield takeEvery(GET_LOG_PAYMENT_BY_ID, getLogPaymentById);
  yield takeEvery(ADD_LOG_PAYMENTS, addLogPayments);
  yield takeEvery(UPDATE_LOG_PAYMENTS, updateLogPayments);
  yield takeEvery(DELETE_LOG_PAYMENTS, deleteLogPayments);

  yield takeEvery(GET_LOG_TDS, getLogTDS);
  yield takeEvery(GET_LOG_TDS_BY_ID, getLogTDSById);
  yield takeEvery(ADD_LOG_TDS, addLogTDS);
  yield takeEvery(UPDATE_LOG_TDS, updateLogTDS);
  yield takeEvery(DELETE_LOG_TDS, deleteLogTDS);

  yield takeEvery(START_PRODUCTION, startProduction);
  yield takeEvery(GET_PRODUCTION, getProductions);
  yield takeEvery(GET_PRODUCTION_BY_ID, getProductionById);
  yield takeEvery(GET_BULK_PRODUCTION, getBulkProduction);
  yield takeEvery(GET_BULK_PRODUCTIONS, getBulkProductions);
  yield takeEvery(GET_REMAINING_PRODUCTION, getRemainingProduction);
  yield takeEvery(ISSUE_RAW_MATERIAL, issueRawMaterial);
  yield takeEvery(UPDATE_PROCESS, updateProcess);
  yield takeEvery(UPDATE_COST, updateCost);
  yield takeEvery(SAVE_FINISHED_GOODS, saveFinishedGoods);
  yield takeEvery(SAVE_REWORK, saveRework);
  yield takeEvery(UPDATE_PRODUCTION_STATUS, updateProductionStatus);
  yield takeEvery(UPDATE_SCRAP_LOGS, updateScrapLogs);
  yield takeEvery(SAVE_PRODUCTION, saveProduction);
  yield takeEvery(MATERIAL_PLANNING, materialPlanning);
  yield takeEvery(MIN_STOCK_MATERIAL_PLANNING, minStockMaterialPlanning);
  yield takeEvery(BOM_BASED_MATERIAL_PLANNING, bomBasedMaterialPlanning);
  yield takeEvery(GET_PRODUCTIONS_BY_COMPANY_ID, getProductionsByCompanyId);
  yield takeEvery(PRODUCTION_BASED_MATERIAL_PLANNING, productionBasedMaterialPlanning);
  yield takeEvery(UPDATE_TABLE, updateTable);
  yield takeEvery(LINK_BOM, linkBom);
  yield takeEvery(UNLINK_BOM, unlinkBom);
  yield takeEvery(GET_ALL_REJECT_STORE_ITEMS, getAllRejectStoreItems);
  yield takeEvery(REMOVE_ROWS, removeRows);
  yield takeEvery(START_BULK_PRODUCTION, startBulkProduction);
  yield takeEvery(DISCARD_PRODUCTION, discardProduction);
  yield takeEvery(BULK_ISSUE, bulkIssue);
  yield takeEvery(UPDATE_START_DATE, updateStartDate);

  yield takeEvery(GET_REPORTS, getReports);

  yield takeEvery(GET_SETTING, getSetting);
  yield takeEvery(UPDATE_SETTING, updateSetting);

  yield takeEvery(BULK_STOCK_UPDATE, bulkStockUpdate);
  yield takeEvery(GET_SERVICE_CHALLAN_ITEMS, getServiceChallanItems);
  yield takeEvery(GET_FIFO_PRICE, getFifoPrice);

  yield takeEvery(SET_APPROVAL_PERMISSION, setApprovalPermission);
  yield takeEvery(GET_APPROVAL_PERMISSION, getApprovalPermission);
  yield takeEvery(DELETE_APPROVAL_PERMISSION, deleteApprovalPermission);
  yield takeEvery(APPROVED_DOCUMENT, approveDocument);
  yield takeEvery(GET_TABLE_DOCUMENTS, getTableDocuments);

  yield takeEvery(GET_INVENTORY_APPROVAL, getInventoryApprovals);
  yield takeEvery(GET_INVENTORY_APPROVAL_BY_ID, getInventoryApprovalById);
  yield takeEvery(ACCEPT_REJECT_APPROVAL, acceptRejectInventoryApproval);

  yield takeEvery(GET_BOM_APPROVALS, getBOMApprovals);
  yield takeEvery(GET_BOM_APPROVAL_BY_ID, getBOMApprovalById);
  yield takeEvery(ACCEPT_REJECT_BOM_APPROVAL, acceptRejectBOMApproval);
  yield takeEvery(SET_BOM_APPROVAL_PERMISSION, setBOMApprovalPermission);
  yield takeEvery(GET_BOM_APPROVAL_PERMISSION, getBOMApprovalPermission);
  yield takeEvery(DELETE_BOM_APPROVAL_PERMISSION, deleteBOMApprovalPermission);

  yield takeEvery(VIEW_PRODUCTION_HISTORY, viewProductionHistory);
  yield takeEvery(RETURN_RAW_MATERIAL, returnRawMaterial);

  yield takeEvery(CREATE_EINVOICE_CREDENTIAL, createEInvoiceCredential);
  yield takeEvery(GET_EINVOICE_CREDENTIAL, getEInvoiceCredential);
  yield takeEvery(UPDATE_EINVOICE_CREDENTIAL, updateEInvoiceCredential);
  yield takeEvery(DELETE_EINVOICE_CREDENTIAL, deleteEInvoiceCredential);


  yield takeEvery(CREATE_EMAIL_CREDENTIAL, createEmailCredential);
  yield takeEvery(GET_EMAIL_CREDENTIAL, getEMailCredential);
  yield takeEvery(UPDATE_EMAIL_CREDENTIAL, updateEMailCredential);
  yield takeEvery(DELETE_EMAIL_CREDENTIAL, deleteEMailCredential);
  yield takeEvery(COMPLETIONS, amyCompletions);
  yield takeEvery(REPORTS, amyReports);

  yield takeEvery(GET_COLUMNS, getAllColumns);
  yield takeEvery(ADD_COLUMNS, addColumns);
  yield takeEvery(EDIT_COLUMNS, editColumns);
  yield takeEvery(DELETE_COLUMNS, deleteColumns);

  yield takeEvery(GET_GATE_ENTRIES_BY_ID, getGateEntriesById);
  yield takeEvery(GET_ALL_GATE_ENTRIES, getAllGateEntries);
  yield takeEvery(UPDATE_GATE_ENTRY, updateGateEntry);
  yield takeEvery(CREATE_GATE_ENTRY, createGateEntry);
}

export default easeMarginSagas;
